<template>
  <div class="dettaglio_bolla" style="min-height: calc(70vh)">
    <v-overlay :value="caricamento" z-index="999">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <header>
      <v-toolbar dense dark color="indigo" primary-title>
        <v-toolbar-title class="white--text">
          {{
            dettaglio.num_documento != null
              ? "Documento N. " + dettaglio.num_documento
              : "Nuovo Documento"
          }}</v-toolbar-title
        >
        <v-spacer></v-spacer>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              class="mr-2"
              small
              light
              v-bind="attrs"
              v-on="on"
              @click="salvaDati()"
            >
              <v-icon color="success">mdi-floppy</v-icon>
            </v-btn>
          </template>
          <span>Salva Documento</span>
        </v-tooltip>

        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              @click="showDialogAllegatoDocumento"
              class="mr-2"
              small
              light
              v-bind="attrs"
              v-on="on"
            >
              <v-icon color="primary">mdi-paperclip</v-icon>
            </v-btn>
          </template>
          <span>Gestione Allegati</span>
        </v-tooltip>

        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              small
              light
              v-bind="attrs"
              v-on="on"
              @click="
                clickAggiungiSegnalazione(
                  'id_documento',
                  dettaglio.id_documento_tmp,
                  'documento',
                  {
                    cod_documento: 'DDT',
                    num_documento: dettaglio.num_documento,
                    cod_articolo: '',
                  }
                )
              "
            >
              <v-icon color="orange">mdi-alert</v-icon>
            </v-btn>
          </template>
          <span>Segnalazioni</span>
        </v-tooltip>

        <v-spacer></v-spacer>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              small
              v-on="on"
              v-bind="attrs"
              light
              @click="$emit('goBack')"
            >
              <v-icon color="error">mdi-keyboard-backspace</v-icon>
            </v-btn>
          </template>
          <span>Indietro</span>
        </v-tooltip>
      </v-toolbar>
    </header>
    <v-container fluid>
      <v-form ref="bolla_form">
        <v-row class="mx-0" justify="center" align="center">
          <v-spacer></v-spacer>
          <v-col cols="2">
            <v-text-field
              @keyup.enter.native="goToAnagrafica"
              label="Cod. Fornitore"
              v-model="dettaglio.cod_anagrafica"
              required
              :rules="regole.no_null_str"
            >
            </v-text-field>
          </v-col>
          <v-col cols="2">
            <v-text-field
              @keyup.enter.native="goToAnagrafica"
              label="Des. Fornitore"
              v-model="dettaglio.ragione_sociale"
              required
              :rules="regole.no_null_str"
            >
            </v-text-field>
          </v-col>

          <v-col cols="2">
            <!-- Bottone di ricerca fornitore specifico -->
            <div>
              <div style="display: inline-block">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      class="mr-2"
                      small
                      v-on="on"
                      v-bind="attrs"
                      @click="goToAnagrafica"
                      ><v-icon color="success">mdi-check</v-icon>
                    </v-btn>
                  </template>
                  <span>Vai al fornitore</span>
                </v-tooltip>
              </div>

              <!-- Bottone di ricerca fornitore -->
              <div style="display: inline-block">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      class="mr-2"
                      small
                      v-on="on"
                      v-bind="attrs"
                      @click="getAnagrafica"
                      @keyup.enter.native="getAnagrafica"
                      ><v-icon color="primary">mdi-magnify</v-icon>
                    </v-btn>
                  </template>
                  <span>Cerca fornitore</span>
                </v-tooltip>
              </div>

              <!-- Bottone di ricerca per QR code -->
              <div style="display: inline-block">
                <DataMatrixReader
                  ref="qr"
                  @clickChiudi="qr_attivo = false"
                  v-on:detectQrCode="detectQrCodeFornitore"
                />
              </div>
            </div>
          </v-col>
          <v-spacer></v-spacer>
          <v-col cols="2">
            <v-text-field
              label="Numero Documento"
              prepend-icon="mdi-file-document-multiple"
              v-model="dettaglio.num_documento"
              required
              :rules="regole.no_null_str"
            ></v-text-field>
          </v-col>
          <v-spacer></v-spacer>
          <v-col cols="2">
            <InputCalendario
              label="Data"
              v-model="dettaglio.data_documento"
              required
              :rules="regole.no_null_str"
            />
          </v-col>
          <v-spacer></v-spacer>
        </v-row>
      </v-form>

      <v-row>
        <v-col cols="12">
          <v-data-table :headers="tabella.testata" :items="tabella.dati">
            <template v-slot:top>
              <v-toolbar color="indigo" dense>
                <v-toolbar-title class="white--text">
                  Articoli in Accettazione
                </v-toolbar-title>
                <v-spacer></v-spacer>
                <DataMatrixReader
                  :disabled="
                    !dettaglio.id_anagrafica ||
                    dettaglio.ragione_sociale === undefined ||
                    dettaglio.num_documento === null ||
                    dettaglio.num_documento === undefined ||
                    synch_dettaglio === 1 ||
                    dettaglio.num_documento === ''
                  "
                  ref="qr"
                  @clickChiudi="qr_attivo = false"
                  v-on:detectQrCode="detectQrCode"
                />
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      class="mx-5"
                      @click="clickStampaAccettazioni('filtro')"
                      :disabled="
                        tabella.dati.filter((e) => e.stampa === true).length ===
                          0 ||
                        dettaglio.num_documento === null ||
                        dettaglio.num_documento === undefined ||
                        dettaglio.num_documento === ''
                      "
                      small
                      v-bind="attrs"
                      v-on="on"
                    >
                      <v-icon color="purple"> mdi-printer </v-icon>
                    </v-btn>
                  </template>
                  <span>Stampa Selezione</span>
                </v-tooltip>

                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      class="mr-5"
                      @click="clickStampaAccettazioni('totale')"
                      :disabled="
                        !dettaglio.id_anagrafica ||
                        dettaglio.num_documento === null ||
                        dettaglio.num_documento === undefined ||
                        synch_dettaglio === 1 ||
                        dettaglio.num_documento === ''
                      "
                      small
                      v-bind="attrs"
                      v-on="on"
                    >
                      <v-icon color="primary"> mdi-printer </v-icon>
                    </v-btn>
                  </template>
                  <span>Stampa Etichette</span>
                </v-tooltip>

                <!-- Bottone di aggiunta -->
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      class="mr-5"
                      :disabled="
                        !dettaglio.id_anagrafica ||
                        dettaglio.num_documento === null ||
                        dettaglio.num_documento === undefined ||
                        synch_dettaglio === 1 ||
                        dettaglio.num_documento === ''
                      "
                      v-on="on"
                      v-bind="attrs"
                      small
                      @click="mostraDialog(null)"
                    >
                      <v-icon color="primary">mdi-plus</v-icon>
                    </v-btn>
                  </template>
                  <span>Aggiungi Articolo</span>
                </v-tooltip>

                <!-- Bottone della selezione massiva articoli da ordine -->
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      class="mr-5"
                      :disabled="
                        !dettaglio.id_anagrafica ||
                        dettaglio.num_documento === null ||
                        dettaglio.num_documento === undefined ||
                        synch_dettaglio === 1 ||
                        dettaglio.num_documento === ''
                      "
                      small
                      v-on="on"
                      v-bind="attrs"
                      light
                      @click="clickSelectMassDaOrdine"
                    >
                      <v-icon color="primary">mdi-file-edit</v-icon>
                    </v-btn>
                  </template>
                  <span>Selezione Massiva per Ordine</span>
                </v-tooltip>

                <!-- Bottone della selezione massiva articoli da articolo -->
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      :disabled="
                        !dettaglio.id_anagrafica ||
                        dettaglio.num_documento === null ||
                        dettaglio.num_documento === undefined ||
                        synch_dettaglio === 1 ||
                        dettaglio.num_documento === ''
                      "
                      small
                      v-on="on"
                      v-bind="attrs"
                      light
                      @click="clickSelectMassDaArticolo"
                    >
                      <v-icon color="primary">mdi-dolly</v-icon>
                    </v-btn>
                  </template>
                  <span>Selezione Massiva per Articolo</span>
                </v-tooltip>
                <v-spacer></v-spacer>
              </v-toolbar>
            </template>

            <template v-slot:item="{ item }">
              <tr
                class="record_tabella"
                :data-deleted="item.validita == 0 ? true : false"
              >
                <!--<td style="text-align: left">
                  <v-btn
                    class="mx-1 mb-1 mt-1"
                    small
                    @click="mostraDialog(item)"
                    :disabled="item.validita == 0 ? true : false"
                    ><v-icon color="primary">mdi-pencil</v-icon></v-btn
                  >
                </td>-->
                <td>
                  <v-btn
                    class="mx-1 mb-1"
                    @click="mostraDialog(item, true)"
                    :disabled="item.validita == 0 ? true : false"
                    small
                    v-show="synch_dettaglio != 1"
                    ><v-icon color="primary">mdi-pencil</v-icon>
                  </v-btn>
                </td>
                <!-- Colonna della clonazione -->
                <td>
                  <v-btn
                    class="mx-1 mb-1"
                    @click="clonaRiga(item)"
                    :disabled="item.validita == 0 ? true : false"
                    small
                    ><v-icon color="primary">mdi-content-copy</v-icon>
                  </v-btn>
                </td>
                <td
                  v-for="(colonna, i) in tabella.testata"
                  :key="i"
                  v-show="colonna.value != null"
                >
                  <!-- Colonna del numero pallet -->
                  <div
                    style="min-width: 50px"
                    v-if="colonna.value == 'n_pallet'"
                  >
                    {{ tabella.dati.indexOf(item) + 1 }}
                  </div>
                  <!-- Colonna del lotto fornitore -->
                  <div
                    style="min-width: 150px"
                    v-if="colonna.value == 'lotto_fornitore'"
                  >
                    <v-btn
                      @click="editLottoFornitore(item)"
                      color="primary"
                      icon
                      small
                    >
                      <v-icon>mdi-warehouse</v-icon>
                    </v-btn>
                    <span
                      :key="key_lotto_tabella"
                      :style="{
                        color:
                          (item.lotto_fornitore == null ||
                            item.lotto_fornitore === '') &&
                          item.gestione_lotto == 1
                            ? 'red'
                            : 'black',
                      }"
                    >
                      {{
                        item.lotto_fornitore == null ||
                        item.lotto_fornitore == ""
                          ? "N/D"
                          : item.lotto_fornitore
                      }}
                    </span>
                  </div>
                  <!-- Altre colonne -->
                  <span v-else>
                    {{ item[colonna.value] }}
                  </span>
                </td>
                <td>
                  <v-simple-checkbox color="primary" v-model="item.stampa">
                  </v-simple-checkbox>
                </td>
                <td>
                  <v-btn
                    class="mx-1 mb-1"
                    @click="showDialogAllegatoRiga(item)"
                    :disabled="item.validita == 0 ? true : false"
                    small
                    v-show="synch_dettaglio != 1"
                    ><v-icon color="primary">mdi-paperclip</v-icon></v-btn
                  >
                </td>
                <td>
                  <v-btn
                    @click="
                      clickAggiungiSegnalazione(
                        'id_documento_dettaglio',
                        item.id_documento_dettaglio_tmp,
                        'documento_dettaglio',
                        {
                          cod_documento: 'DDT',
                          num_documento: dettaglio.num_documento,
                          cod_articolo: item.cod_articolo,
                        }
                      )
                    "
                    class="mx-1 mb-1"
                    :disabled="item.validita == 0 ? true : false"
                    small
                    v-show="synch_dettaglio != 1"
                    ><v-icon color="orange">mdi-alert</v-icon></v-btn
                  >
                </td>
                <td>
                  <v-btn
                    @click="
                      item.validita == 1
                        ? eliminaRiga(item)
                        : ripristinaRiga(item)
                    "
                    small
                    v-show="synch_dettaglio != 1"
                    ><v-icon
                      :color="item.validita == 0 ? 'primary' : 'error'"
                      >{{
                        item.validita == 1 ? "mdi-close" : "mdi-restore"
                      }}</v-icon
                    ></v-btn
                  >
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </v-container>

    <!-- DIALOG AGG ART -->
    <v-dialog persistent v-model="dialog_inserimento.mostra" width="700">
      <v-card>
        <v-toolbar color="indigo" dense dark>
          <v-toolbar-title
            >{{
              dialog_buffer.id_documento_dettaglio == null
                ? "Aggiungi Articolo"
                : "Modifica Articolo"
            }}
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                class="mr-2 ml-2"
                v-on="on"
                v-bind="attrs"
                @click="clickDialogOrdini"
                light
                small
              >
                <v-icon color="primary">mdi-file-document-multiple</v-icon>
              </v-btn>
            </template>
            <span>Ordini</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-on="on"
                v-bind="attrs"
                @click="salvaModifiche"
                light
                small
              >
                <v-icon color="success">mdi-floppy</v-icon>
              </v-btn>
            </template>
            <span>Salva Articolo</span>
          </v-tooltip>

          <v-spacer></v-spacer>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-on="on"
                v-bind="attrs"
                @click="
                  dialog_inserimento.mostra = false;
                  qr_attivo = false;
                "
                light
                small
              >
                <v-icon color="error">mdi-keyboard-backspace</v-icon>
              </v-btn>
            </template>
            <span>Indietro</span>
          </v-tooltip>
        </v-toolbar>

        <v-container>
          <v-form ref="form">
            <v-row align="center" class="mt-1" justify="center">
              <v-col class="pb-0">
                <v-row align="center" justify="center">
                  <v-text-field
                    class="ml-3"
                    label="Cod. Articolo"
                    dense
                    hide-details
                    required
                    :rules="regole.no_null_str"
                    v-model="dialog_buffer.cod_articolo"
                  ></v-text-field>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        class="mr-2 ml-3"
                        v-on="on"
                        v-bind="attrs"
                        @click="goToArticolo"
                        small
                      >
                        <v-icon color="success">mdi-check</v-icon>
                      </v-btn>
                    </template>
                    <span>Vai all'Articolo</span>
                  </v-tooltip>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        class="mr-2"
                        v-on="on"
                        v-bind="attrs"
                        @click="getArticoli"
                        small
                      >
                        <v-icon color="primary">mdi-magnify</v-icon>
                      </v-btn>
                    </template>
                    <span>Cerca</span>
                  </v-tooltip>
                </v-row>
              </v-col>
              <v-col class="pb-0">
                <v-text-field
                  dense
                  hide-details
                  label="Descrizione"
                  v-model="dialog_buffer.descrizione"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row justify="center" align="center">
              <v-col class="pb-0">
                <v-text-field
                  dense
                  hide-details
                  label="Numero Colli"
                  type="number"
                  v-model.number="dialog_buffer.num_colli"
                  required
                  :rules="regole.no_null_num"
                ></v-text-field>
              </v-col>
              <v-col align="center" justify="cener">
                <span
                  style="font-size: 11px; color: rgba(0, 0, 0, 0.6)"
                  class="ml-n12 mt-n5"
                >
                  Quantità per Collo
                </span>
                <v-switch
                  hide-details
                  class="mt-0 pt-0"
                  dense
                  v-model="dialog_buffer.qta_per_collo"
                ></v-switch>
              </v-col>
              <v-col class="pb-0">
                <!-- 
                  :label="
                    dialog_buffer.qta_per_collo === true
                      ? 'Quantità Collo'
                      : `Qtà Arrivo (Residua ${
                          dialog_buffer.quantita_max_prelevabile == null
                            ? 'N/D'
                            : dialog_buffer.quantita_max_prelevabile
                        })`
                  "
                 -->
                <v-text-field
                  dense
                  hide-details
                  type="number"
                  :label="
                    dialog_buffer.qta_per_collo === true
                      ? 'Quantità Collo'
                      : `Qtà Arrivo`
                  "
                  min="0"
                  v-model.number="dialog_buffer.quantita"
                  required
                  :rules="regole.no_null_num"
                ></v-text-field>
              </v-col>
              <v-col class="pb-0">
                <div
                  style="
                    border-bottom: 1px solid black;
                    margin-top: 4px;
                    padding-bottom: 2px;
                    text-align: left;
                  "
                >
                  UM Articolo:
                  <span style="font-size: 16px; font-weight: bold">{{
                    items_um.filter((e) => e.id_tabella == dialog_buffer.id_um)
                      .length > 0
                      ? items_um.filter(
                          (e) => e.id_tabella == dialog_buffer.id_um
                        )[0].des
                      : "N/D"
                  }}</span>
                </div>
              </v-col>
            </v-row>
            <v-row align="center" justify="start">
              <v-col class="pb-0" cols="6">
                <v-text-field
                  dense
                  hide-details
                  label="Lotto Fornitore"
                  v-model="dialog_buffer.lotto_fornitore"
                ></v-text-field>
              </v-col>
              <v-col class="pb-0" cols="3">
                <v-text-field
                  dense
                  hide-details
                  label="Peso Netto"
                  type="number"
                  v-model.number="dialog_buffer.peso_netto"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row justify="center">
              <v-col class="pb-0" cols="6">
                <v-text-field
                  dense
                  hide-details
                  label="Lotto Assegnato"
                  readonly
                  v-model="dialog_buffer.cod_lotto"
                ></v-text-field>
              </v-col>
              <v-col class="pb-0" cols="3">
                <v-text-field
                  dense
                  hide-details
                  label="Peso Lordo"
                  type="number"
                  v-model.number="dialog_buffer.peso_lordo"
                ></v-text-field>
              </v-col>
              <v-col class="pb-0" cols="3">
                <v-autocomplete
                  dense
                  hide-details
                  :items="items_um_peso"
                  item-text="des"
                  item-value="id_tabella"
                  label="UM Peso"
                  v-model="dialog_buffer.um_peso"
                ></v-autocomplete>
              </v-col>
            </v-row>
            <v-row align="center" justify="center">
              <v-col cols="6">
                <v-text-field
                  dense
                  hide-details
                  label="Num. Seriale"
                  v-model="dialog_buffer.seriale"
                ></v-text-field>
              </v-col>
              <v-col cols="3">
                <v-text-field
                  dense
                  hide-details
                  label="Rif. Ordine"
                  readonly
                  v-model="dialog_buffer.num_ordine"
                ></v-text-field>
              </v-col>
              <v-col cols="3">
                <v-text-field
                  dense
                  hide-details
                  label="Riga Ordine"
                  readonly
                  v-model="dialog_buffer.riga_ordine"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row align="start" justify="start">
              <v-col cols="6">
                <v-autocomplete
                  dense
                  hide-details
                  :items="items_magazzini"
                  item-text="des_magazzino"
                  item-value="id_magazzino"
                  label="Magazzino Destinazione"
                  v-model="dialog_buffer.id_magazzino"
                >
                </v-autocomplete>
              </v-col>
              <v-col cols="6">
                <v-text-field
                  dense
                  hide-details
                  label="Prezzo"
                  type="number"
                  v-model.number="dialog_buffer.prezzo_totale"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row align="start" justify="center">
              <v-col cols="6">
                <v-menu
                  v-model="calendario_data_scadenza"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  min-width="289"
                  transition="scale-transition"
                  offset-y
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      background-color="#ffffff"
                      dense
                      hide-details
                      label="Data Scadenza"
                      v-model="data_scadenza_formattata"
                      readonly
                      v-on="on"
                    >
                    </v-text-field>
                  </template>
                  <v-date-picker
                    v-model="dialog_buffer.data_scadenza"
                    @input="calendario_data_scadenza = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="6">
                <v-textarea
                  dense
                  hide-details
                  label="Note Riga"
                  outlined
                  rows="2"
                  style="border-radius: 0px"
                  v-model="dialog_buffer.note_riga"
                ></v-textarea>
              </v-col>
            </v-row>
          </v-form>
          <v-row align="center" justify="center">
            <v-col cols="12">
              <DropFile
                :allegati="dialog_buffer.allegati ? dialog_buffer.allegati : []"
                :max_tmb_dimension="75"
                ref="DropFileDettaglio"
                :visible="dialog_inserimento.mostra"
                v-if="dialog_inserimento.mostra == true"
              />
            </v-col>
          </v-row>
        </v-container>
        <v-overlay :value="caricamento" z-index="999">
          <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
      </v-card>
    </v-dialog>

    <!-- DIALOG ricerca cod articolo -->
    <v-dialog v-model="dialog_lista.mostra" width="700" persistent>
      <v-card>
        <v-toolbar color="indigo" dense dark>
          <v-toolbar-title>Seleziona Articolo</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn @click="chiudiDialogRicercaArt" light small>
            <v-icon color="error">mdi-keyboard-backspace</v-icon>
          </v-btn>
        </v-toolbar>
        <v-container>
          <v-row>
            <v-col cols="12">
              <v-data-table
                :headers="dialog_lista.tabella.testata"
                :items="dialog_lista.tabella.dati"
              >
                <template v-slot:item="{ item }">
                  <tr
                    class="record_tabella"
                    :data-deleted="item.validita == 0 ? true : false"
                  >
                    <td>
                      <v-btn small @click="selezionaArticolo(item)">
                        <v-icon color="primary">mdi-check</v-icon>
                      </v-btn>
                    </td>
                    <td
                      v-for="(colonna, i) in dialog_lista.tabella.testata"
                      :key="i"
                      v-show="colonna.value != null"
                    >
                      {{ item[colonna.value] }}
                    </td>
                  </tr>
                </template>
              </v-data-table>
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </v-dialog>

    <!-- Dialog lista Ordini -->
    <v-dialog v-model="dialog_lista_ordini" width="1000" persistent>
      <v-card>
        <v-data-table :headers="tabellaOrdini.testata" :items="items_articoli">
          <template v-slot:top>
            <v-toolbar color="indigo" dense>
              <v-toolbar-title class="white--text">
                Lista Ordini
              </v-toolbar-title>
              <v-spacer></v-spacer>
              <v-col>
                <v-autocomplete
                  solo
                  light
                  dense
                  hide-details
                  background-color="#ffffff"
                  @change="filtra"
                  :items="items_articoli"
                  item-text="COD_ARTICOLO"
                  item-value="COD_ARTICOLO"
                  label="Cerca Articolo"
                  v-model="articoli_search"
                />
              </v-col>

              <!-- Bottone di ricerca  -->
              <v-tooltip right>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    class="mr-5"
                    v-on="on"
                    v-bind="attrs"
                    small
                    @click="eliminaFiltro"
                  >
                    <v-icon color="primary">mdi-filter-off</v-icon>
                  </v-btn>
                </template>
                <span>Chiudi Ricerca</span>
              </v-tooltip>

              <!-- Bottone di aggiornamento -->
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    small
                    v-on="on"
                    v-bind="attrs"
                    light
                    @click="getOrdini"
                  >
                    <v-icon color="success">mdi-sync</v-icon>
                  </v-btn>
                </template>
                <span>Aggiorna Ordini</span>
              </v-tooltip>

              <v-spacer></v-spacer>

              <!-- Bottone di chiusura -->
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    small
                    v-on="on"
                    v-bind="attrs"
                    light
                    @click="backFromListaOrdini"
                  >
                    <v-icon color="error">mdi-keyboard-backspace</v-icon>
                  </v-btn>
                </template>
                <span>Indietro</span>
              </v-tooltip>
            </v-toolbar>
          </template>

          <template v-slot:item="{ item }">
            <tr
              class="record_tabella"
              :data-deleted="item.validita == 0 ? true : false"
              :style="
                item.QUANTITA < 0 && item.QUANTITA >= -500
                  ? 'background:#fbd287;'
                  : item.QUANTITA < -500
                  ? 'background:#fda1a1;'
                  : ''
              "
            >
              <td>
                <v-btn small @click="clickItemListaOrdini(item)">
                  <v-icon color="primary">mdi-check</v-icon>
                </v-btn>
              </td>

              <td>{{ item.NUM_ORDINE }}</td>
              <td>{{ item.COD_ARTICOLO }}</td>
              <td>{{ item.descrizione }}</td>
              <td>{{ item.NUM_SERIALE }}</td>
              <td>
                {{
                  item.DATA_DOCUMENTO
                    ? item.DATA_DOCUMENTO.includes("-")
                      ? `${item.DATA_DOCUMENTO.split("-")[2]}/${
                          item.DATA_DOCUMENTO.split("-")[1]
                        }/${item.DATA_DOCUMENTO.split("-")[0]}`
                      : item.DATA_DOCUMENTO.includes("/")
                      ? item.DATA_DOCUMENTO
                      : "N/A"
                    : "N/A"
                }}
              </td>
              <td>
                {{
                  item.DATA_CONSEGNA
                    ? item.DATA_CONSEGNA.includes("-")
                      ? `${item.DATA_CONSEGNA.split("-")[2]}/${
                          item.DATA_CONSEGNA.split("-")[1]
                        }/${item.DATA_CONSEGNA.split("-")[0]}`
                      : item.DATA_CONSEGNA.includes("/")
                      ? item.DATA_CONSEGNA
                      : "N/A"
                    : "N/A"
                }}
              </td>
              <td>{{ item.QUANTITA }}</td>
            </tr>
          </template>
        </v-data-table>
        <v-overlay :value="caricamento" z-index="999">
          <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
      </v-card>
    </v-dialog>

    <!-- Dialog Conferma -->
    <v-dialog v-model="dialogConfReg" width="700" persistent>
      <v-card>
        <v-toolbar color="indigo" dense dark>
          <v-toolbar-title>Conferma Registrazione</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-title
            >Quantità:
            {{ dialog_buffer.quantita ? dialog_buffer.quantita : "" }}/{{
              qtaDisp ? qtaDisp : ""
            }}</v-toolbar-title
          >
          <v-spacer></v-spacer>
          <v-btn @click="chiudiDialogConfermaReg" light small>
            <v-icon color="error">mdi-keyboard-backspace</v-icon>
          </v-btn>
        </v-toolbar>
        <v-container>
          <v-row>
            <v-col cols="12">
              <v-data-table
                v-if="array_tmp_ord_qnt.length"
                :headers="headersConf"
                :items="array_tmp_ord_qnt"
              >
                <template v-slot:[`item.DATA_DOCUMENTO`]="{ item }">
                  {{
                    item.DATA_DOCUMENTO != null &&
                    item.DATA_DOCUMENTO != undefined &&
                    item.DATA_DOCUMENTO != ""
                      ? `${item.DATA_DOCUMENTO.split("-")[2]}

                      /${item.DATA_DOCUMENTO.split("-")[1]}

                      /${item.DATA_DOCUMENTO.split("-")[0]}`
                      : "N/A"
                  }}
                </template>
                <template v-slot:[`item.DATA_CONSEGNA`]="{ item }">
                  {{
                    item.DATA_CONSEGNA != null &&
                    item.DATA_CONSEGNA != undefined &&
                    item.DATA_CONSEGNA != ""
                      ? `${item.DATA_CONSEGNA.split("-")[2]}

                      /${item.DATA_CONSEGNA.split("-")[1]}

                      /${item.DATA_CONSEGNA.split("-")[0]}`
                      : "N/A"
                  }}
                </template>
              </v-data-table>
            </v-col>
          </v-row>
          <v-row align="center" justify="center">
            <v-col cols="6">
              <v-btn color="error" @click="chiudiDialogConfermaReg"
                >Annulla</v-btn
              >
            </v-col>
            <v-col cols="6" v-if="dialog_buffer.quantita <= qtaDisp + 500">
              <v-btn @click="confermaRegMultiRiga" color="success">
                Conferma
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </v-dialog>

    <!-- DIALOG RICHERCA FORNITORE -->
    <v-dialog v-model="dialogSearchAnagrafica" width="700" persistent>
      <v-card>
        <v-toolbar color="indigo" dense dark>
          <v-toolbar-title>Seleziona Fornitore</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn @click="chiudiDialogRicercaFornitore" light small>
            <v-icon color="error">mdi-keyboard-backspace</v-icon>
          </v-btn>
        </v-toolbar>
        <v-container>
          <v-row>
            <v-col cols="12">
              <v-data-table
                :headers="ragioneSociale"
                :items="ragioneSocialeLista"
              >
                <template v-slot:item="{ item }">
                  <tr
                    class="record_tabella"
                    :data-deleted="item.validita == 0 ? true : false"
                  >
                    <td>
                      <v-btn small @click="selezionaAnagrafica(item)"
                        ><v-icon color="primary">mdi-check</v-icon></v-btn
                      >
                    </td>
                    <td
                      v-for="(colonna, i) in ragioneSociale"
                      :key="i"
                      v-show="colonna.value != null"
                    >
                      {{ item[colonna.value] }}
                    </td>
                  </tr>
                </template>
              </v-data-table>
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </v-dialog>

    <!-- Dialog conferma ordini  -->
    <v-dialog v-model="dialog_conferma_ordine" width="unset" persistent>
      <v-card>
        <v-toolbar class="white--text" color="indigo" flat>
          <v-toolbar-title>Conferma Selezione</v-toolbar-title>
        </v-toolbar>
        <v-card-text class="mt-5">
          Vuoi registrare l'articolo:
          <b>{{ ordine_tmp == null ? "" : ordine_tmp.COD_ARTICOLO }}</b>
          dell'ordine:
          <b>{{ ordine_tmp == null ? "" : ordine_tmp.NUM_ORDINE }}</b>
          ?
        </v-card-text>
        <v-divider></v-divider>
        <v-btn class="mx-2 my-2" @click="annullaSelezioneOrdine" small>
          <v-icon color="error">mdi-close</v-icon>
        </v-btn>
        <v-btn class="mx-2 my-2" @click="selezionaOrdine(ordine_tmp)" small>
          <v-icon color="success">mdi-check</v-icon>
        </v-btn>
      </v-card>
    </v-dialog>

    <!-- Dialog Registrazione Superiore -->

    <!-- <v-dialog v-model="dialog_cnf_reg_qnt_sup" width="500" persistent>
      <v-card>
        <v-toolbar color="indigo" dense dark>
          <v-toolbar-title>Conferma la Registrazione</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn light small>
            <v-icon color="error">mdi-keyboard-backspace</v-icon>
          </v-btn>
        </v-toolbar>
        <v-container>
          <v-card-text class="mt-5">
            Stai registrando una quantità superiore alla quantità disponibile
            nell'ordine.
          </v-card-text>
          <v-row align="center">
            <v-col cols="6">
              <v-btn color="error">Annulla</v-btn>
            </v-col>
            <v-col cols="6">
              <v-btn @click="confermaRegSuper" color="success">Conferma</v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </v-dialog> -->

    <!-- Dialog di conferma della stampa -->
    <v-dialog v-model="conferma_stampa_visible" width="500px">
      <v-card>
        <v-toolbar color="indigo" dense>
          <v-toolbar-title class="white--text">Conferma Stampa</v-toolbar-title>
          <v-spacer></v-spacer>

          <!-- Bottone di chiusura -->
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="
                  conferma_stampa_visible = false;
                  etichette = [];
                "
                small
                v-bind="attrs"
                v-on="on"
              >
                <v-icon color="error"> mdi-close </v-icon>
              </v-btn>
            </template>
            <span>Chiusi</span>
          </v-tooltip>
        </v-toolbar>
        <v-card-text class="mt-5" style="overflow-y: auto">
          <span style="font-size: 18px" v-if="etichette.length == 0">
            Confermi la stampa delle etichette di n.
            {{
              modalita_stampa == "filtro"
                ? tabella.dati.filter((e) => e.stampa === true).length
                : tabella.dati.length
            }}
            pedane in accettazione?
          </span>
          <v-divider class="my-5" v-if="etichette.length == 0"></v-divider>
          <v-container class="ma-0 pa-0">
            <v-row align="center" justify="center" v-if="etichette.length == 0">
              <v-col cols="12" align="center" justify="center">
                <!-- Bottone di annullamento -->
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      class="mr-5"
                      @click="
                        conferma_stampa_visible = false;
                        etichette = [];
                      "
                      small
                      v-bind="attrs"
                      v-on="on"
                    >
                      <v-icon color="error"> mdi-close </v-icon>
                    </v-btn>
                  </template>
                  <span>Annulla</span>
                </v-tooltip>

                <!-- Bottone di conferma -->
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      class="mr-5"
                      @click="stampaAccettazioni"
                      small
                      v-bind="attrs"
                      v-on="on"
                    >
                      <v-icon color="success"> mdi-check </v-icon>
                    </v-btn>
                  </template>
                  <span>Conferma</span>
                </v-tooltip>
              </v-col>
            </v-row>
            <v-row align="center" justify="center">
              <v-col cols="3" v-for="(etichetta, i) in etichette" :key="i">
                <div>
                  <v-icon
                    @click="showPdfViewer(etichetta.base64)"
                    color="error"
                    size="100"
                    >mdi-file-pdf-box
                  </v-icon>
                </div>
                <div>
                  {{ etichetta.titolo }}
                </div>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>

      <v-overlay :value="overlay_etichette" z-index="999">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
    </v-dialog>

    <!-- Dialog di visualizzazione etichette -->
    <v-dialog v-model="dialog_preview" width="unset">
      <v-card>
        <v-toolbar color="indigo" dense>
          <v-toolbar-title class="white--text">
            Stampa Etichetta
          </v-toolbar-title>

          <v-spacer></v-spacer>

          <!-- Bottone di chiusura -->
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="chiudiDialogPreview"
                small
                v-bind="attrs"
                v-on="on"
              >
                <v-icon color="error"> mdi-close </v-icon>
              </v-btn>
            </template>
            <span>Chiudi</span>
          </v-tooltip>
        </v-toolbar>
        <v-col cols="12">
          <iframe
            :src="iframeUrl"
            frameborder="0"
            style="height: 70vh !important; width: 750px !important"
          >
          </iframe>
        </v-col>
      </v-card>
    </v-dialog>

    <!-- Dialog di riepilogo pre-salvataggio -->
    <v-dialog v-model="dialog_riepilogo" width="unset">
      <v-card>
        <v-toolbar color="indigo" dense>
          <v-toolbar-title class="white--text">
            Riepilogo Accettazioni
          </v-toolbar-title>
        </v-toolbar>
        <v-card-text class="mt-5" style="overflow-y: auto">
          <v-data-table
            :headers="tabella.testata_riepilogo"
            :items="items_riepilogo"
          >
          </v-data-table>

          <!-- Riga di conferma / rifiuto -->
          <v-container class="mt-5 pa-0">
            <v-row align="center" justify="center">
              <v-col cols="12" align="center" justify="center">
                <!-- Bottone di annullamento -->
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      class="mr-5"
                      @click="dialog_riepilogo = false"
                      small
                      v-bind="attrs"
                      v-on="on"
                    >
                      <v-icon color="error"> mdi-close </v-icon>
                    </v-btn>
                  </template>
                  <span>Annulla</span>
                </v-tooltip>

                <!-- Bottone di conferma -->
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      class="mr-5"
                      @click="setDocumento"
                      small
                      v-bind="attrs"
                      v-on="on"
                    >
                      <v-icon color="success"> mdi-check </v-icon>
                    </v-btn>
                  </template>
                  <span>Conferma</span>
                </v-tooltip>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- SEGNALAZIONI -->
    <v-dialog v-model="dialog_segnalazioni">
      <v-card
        class="ma-0 pa-0"
        height="calc(100vh - 100px)"
        style="overflow: hidden"
      >
        <div style="position: relative; height: 100%">
          <WindowFrame
            class="ma-0 pa-0"
            @click_chiudi="closeSegnalazioni"
            :component="'anomalie'"
            :input_args="input_args"
            :key="key_segnalazioni"
            @salvati_disegni="handleSalvatiDisegni"
          />
        </div>
      </v-card>
    </v-dialog>

    <!-- Dialog di selezione massiva dell'ordine -->
    <v-dialog v-model="dialog_selezione_massiva_fornitore">
      <v-card>
        <v-toolbar color="indigo" dense>
          <v-toolbar-title class="white--text">
            Selezione Massiva da Ordine
          </v-toolbar-title>
          <v-spacer></v-spacer>

          <!-- Bottone di salvtaggio -->
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn @click="salvataggioMassivo" small v-bind="attrs" v-on="on">
                <v-icon color="success"> mdi-floppy </v-icon>
              </v-btn>
            </template>
            <span>Salvataggio Massivo</span>
          </v-tooltip>

          <v-spacer></v-spacer>

          <!-- Bottone di chiusura -->
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="dialog_selezione_massiva_fornitore = false"
                small
                v-bind="attrs"
                v-on="on"
                ><v-icon color="error">mdi-close</v-icon></v-btn
              >
            </template>
            <span>Chiudi</span>
          </v-tooltip>
        </v-toolbar>
        <v-card-text style="overflow-y: auto">
          <v-data-table
            class="mt-10"
            height="50vh"
            :headers="headers_art_mass"
            :items="items_art_mass.filter((a) => a.quantita > 0)"
          >
            <template v-slot:top>
              <v-toolbar color="indigo" dense>
                <v-toolbar-title class="white--text">
                  Articoli nell'Ordine Selezionato
                </v-toolbar-title>

                <v-spacer></v-spacer>

                <!-- Autocomplete degli ordini da selezionare -->
                <v-autocomplete
                  @change="selectArtMass"
                  dense
                  hide-details
                  :items="
                    items_select_ord_mass.filter(
                      (o) =>
                        o.dettaglio.filter((d) => d.quantita > 0).length > 0
                    )
                  "
                  item-text="num_documento"
                  item-value="id_documento"
                  outlined
                  style="background-color: white; max-width: 350px"
                  v-model="id_ordine_mass_sel"
                >
                </v-autocomplete>

                <!-- Bottone per la selezione di tutti gli aticoli -->
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      class="ml-5"
                      @click="selezionaTuttiArticoliMassivi"
                      :disabled="items_art_mass.length <= 0"
                      small
                      v-bind="attrs"
                      v-on="on"
                    >
                      <v-icon color="primary"> mdi-check-all </v-icon>
                    </v-btn>
                  </template>
                  <span>Seleziona Tutti gli Articoli</span>
                </v-tooltip>

                <v-spacer></v-spacer>
              </v-toolbar>
            </template>
            <template v-slot:[`item.seleziona`]="{ item }">
              <v-icon
                @click="selezionaOrdineMassivo(item)"
                :color="item.selezionato == 1 ? 'primary' : ''"
                >{{
                  item.selezionato == 1
                    ? "mdi-checkbox-marked"
                    : "mdi-checkbox-blank-outline"
                }}</v-icon
              >
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Dialog di selezione massiva dell'ordine -->
    <v-dialog v-model="dialog_selezione_massiva_articolo">
      <v-card>
        <v-toolbar color="indigo" dense>
          <v-toolbar-title class="white--text">
            Selezione Massiva per Articolo
          </v-toolbar-title>
          <v-spacer></v-spacer>

          <!-- Bottone di salvtaggio -->
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="salvataggioMassivoArticolo"
                small
                v-bind="attrs"
                v-on="on"
              >
                <v-icon color="success"> mdi-floppy </v-icon>
              </v-btn>
            </template>
            <span>Salvataggio Massivo</span>
          </v-tooltip>

          <v-spacer></v-spacer>

          <!-- Bottone di chiusura -->
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="dialog_selezione_massiva_articolo = false"
                small
                v-bind="attrs"
                v-on="on"
                ><v-icon color="error">mdi-close</v-icon></v-btn
              >
            </template>
            <span>Chiudi</span>
          </v-tooltip>
        </v-toolbar>
        <v-card-text style="overflow-y: auto">
          <v-data-table
            class="mt-10"
            height="50vh"
            :headers="headers_art_mass_art"
            :items="items_art_mass_art"
          >
            <template v-slot:top>
              <v-toolbar color="indigo" dense>
                <v-toolbar-title class="white--text">
                  Articoli
                </v-toolbar-title>

                <v-spacer></v-spacer>

                <!-- Autocomplete degli ordini da selezionare (per codice) -->
                <span class="mr-2 white--text"> Cod.: </span>
                <v-autocomplete
                  @change="selectArtMassArt"
                  class="mr-5"
                  dense
                  hide-details
                  :items="items_articoli"
                  item-text="COD_ARTICOLO"
                  item-value="id_articolo"
                  outlined
                  style="background-color: white; max-width: 250px"
                  v-model="id_articolo_mass_sel"
                  :key="id_articolo_mass_sel"
                >
                </v-autocomplete>

                <!-- Autocomplete degli ordini da selezionare (per descrizione) -->
                <span class="mr-2 white--text"> Des.: </span>

                <v-autocomplete
                  @change="selectArtMassArt"
                  class="mr-5"
                  dense
                  hide-details
                  :items="items_articoli"
                  item-text="descrizione"
                  item-value="id_articolo"
                  outlined
                  style="background-color: white; max-width: 250px"
                  v-model="id_articolo_mass_sel"
                  :key="id_articolo_mass_sel"
                >
                </v-autocomplete>

                <!-- Bottone per la selezione di tutti gli aticoli -->
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      @click="selezionaTuttiArticoliMassiviArt"
                      :disabled="items_art_mass_art.length <= 0"
                      small
                      v-bind="attrs"
                      v-on="on"
                    >
                      <v-icon color="primary"> mdi-check-all </v-icon>
                    </v-btn>
                  </template>
                  <span>Seleziona da Tutti gli Ordini</span>
                </v-tooltip>

                <v-spacer></v-spacer>
              </v-toolbar>
            </template>
            <template v-slot:[`item.seleziona`]="{ item }">
              <v-icon
                @click="selezionaArticoloMassivo(item)"
                :color="item.selezionato == 1 ? 'primary' : ''"
                :disabled="item.QUANTITA <= 0"
              >
                {{
                  item.selezionato == 1
                    ? "mdi-checkbox-marked"
                    : "mdi-checkbox-blank-outline"
                }}
              </v-icon>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Dialog di modifica del Lotto Fornitore -->
    <v-dialog v-model="dialog_lotto_fornitore" width="unset">
      <v-card style="max-width: 500px">
        <v-toolbar color="indigo" dense>
          <v-toolbar-title class="white--text">Lotto Fornitore</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                class="ml-10"
                @click="confermaLottoFornitore"
                small
                v-bind="attrs"
                v-on="on"
                ><v-icon color="success">mdi-floppy</v-icon>
              </v-btn>
            </template>
            <span>Conferma</span>
          </v-tooltip>
          <v-spacer></v-spacer>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                class="ml-10"
                @click="dialog_lotto_fornitore = false"
                small
                v-bind="attrs"
                v-on="on"
                ><v-icon color="error">mdi-close</v-icon></v-btn
              >
            </template>
            <span>Chiudi</span>
          </v-tooltip>
        </v-toolbar>
        <v-card-text style="overflow-y: auto">
          <v-text-field v-model="riga_sel.lotto_fornitore"></v-text-field>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Dialog di clonazione della riga -->
    <v-dialog v-model="dialog_clonazione" width="unset">
      <v-card style="max-width: 500px">
        <v-toolbar color="indigo" dense>
          <v-toolbar-title class="white--text">Duplicazione</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                class="ml-10"
                @click="confermaDuplicaRiga"
                small
                v-bind="attrs"
                v-on="on"
                ><v-icon color="success">mdi-floppy</v-icon>
              </v-btn>
            </template>
            <span>Conferma</span>
          </v-tooltip>
          <v-spacer></v-spacer>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                class="ml-10"
                @click="dialog_clonazione = false"
                small
                v-bind="attrs"
                v-on="on"
                ><v-icon color="error">mdi-close</v-icon></v-btn
              >
            </template>
            <span>Chiudi</span>
          </v-tooltip>
        </v-toolbar>
        <v-card-text class="mt-5" style="overflow-y: auto">
          <v-container fluid>
            <v-row align="center" justify="center">
              <v-col align="center">
                <v-text-field
                  dense
                  :label="
                    'Quantità (max ' + riga_clone.quantita_max_prelevabile + ')'
                  "
                  min="0"
                  outlined
                  style="border-radius: 0px"
                  type="number"
                  v-model="riga_clone.quantita"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row align="center" justify="center">
              <v-col align="center" cols="12">
                <v-text-field
                  dense
                  label="Lotto Fornitore"
                  outlined
                  style="border-radius: 0px"
                  v-model="riga_clone.lotto_fornitore"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!--Dialog degli allegati del DDT -->
    <v-dialog v-model="dialog_allegato_documento">
      <v-card>
        <v-toolbar color="indigo" dense>
          <v-toolbar-title class="white--text"> Allegati DDT </v-toolbar-title>
          <v-spacer></v-spacer>
          <!-- Bottone di salvataggio -->
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="saveAllegatiDocumento"
                small
                v-bind="attrs"
                v-on="on"
              >
                <v-icon color="success">mdi-floppy</v-icon>
              </v-btn>
            </template>
            <span>Salva</span>
          </v-tooltip>
          <v-spacer></v-spacer>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="closeAllegatoDocumento"
                small
                v-bind="attrs"
                v-on="on"
              >
                <v-icon color="error">mdi-close</v-icon>
              </v-btn>
            </template>
            <span>Chiudi</span>
          </v-tooltip>
        </v-toolbar>
        <v-card-text>
          <v-container fluid>
            <v-row align="center" justify="center">
              <v-col cols="12">
                <DropFile
                  :allegati="allegati_documento"
                  :flat_card="true"
                  :max_tmb_dimension="75"
                  ref="DropFileDocumento"
                  :show_toolbar="false"
                  :visible="dialog_allegato_documento"
                  v-if="dialog_allegato_documento == true"
                />
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Dialog degli allegati della riga -->
    <v-dialog v-model="dialog_allegato_riga">
      <v-card>
        <v-toolbar color="indigo" dense>
          <v-toolbar-title class="white--text"> Allegati Riga </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn @click="saveAllegatiRiga" small v-bind="attrs" v-on="on">
                <v-icon color="success">mdi-floppy</v-icon>
              </v-btn>
            </template>
            <span>Salva</span>
          </v-tooltip>
          <v-spacer></v-spacer>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn @click="closeAllegatoRiga" small v-bind="attrs" v-on="on">
                <v-icon color="error">mdi-close</v-icon>
              </v-btn>
            </template>
            <span>Chiudi</span>
          </v-tooltip>
        </v-toolbar>
        <v-card-text>
          <v-container fluid>
            <v-row align="center" justify="center">
              <v-col cols="12">
                <DropFile
                  :allegati="
                    dialog_buffer.allegati ? dialog_buffer.allegati : []
                  "
                  :flat_card="true"
                  :max_tmb_dimension="75"
                  ref="DropFileRiga"
                  :show_toolbar="false"
                  :visible="dialog_allegato_riga"
                  v-if="dialog_allegato_riga == true"
                />
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- SNACKBAR -->
    <v-snackbar
      content-class="snackbar"
      :color="snackbar_background"
      right
      v-model="snackbar"
      :timeout="3000"
    >
      <v-icon :color="snackbar_icon_color" :size="64">{{
        snackbar_icon
      }}</v-icon>
      <h2 :style="{ color: snackbar_text_color + '!important' }" class="ml-16">
        {{ snackbar_text }}
      </h2>

      <v-btn
        @click="snackbar = false"
        fab
        dark
        text
        small
        style="
          margin-top: -6rem;
          float: right !important;
          margin-right: -1rem !important;
        "
      >
        <v-icon :color="snackbar_icon_color">mdi-window-close</v-icon>
      </v-btn>
    </v-snackbar>

    <!-- Snackbar -->
    <SnackbarQV ref="SnackbarQV" />
  </div>
</template>
<script>
import _ from "lodash";
import axios from "axios";
import DataMatrixReader from "../../TOOLS/DataMatrixReader.vue";
import DropFile from "@/components/TOOLS/DropFile.vue";
import InputCalendario from "./InputCalendario.vue";
import moment from "moment/moment";
import SnackbarQV from "@/components/TOOLS/SnackbarQV.vue";
import WindowFrame from "@/components/WINDOWFRAME/WindowFrame.vue";

export default {
  name: "DettaglioBolla",
  components: {
    DropFile,
    DataMatrixReader,
    InputCalendario,
    SnackbarQV,
    WindowFrame,
  },
  props: {
    admin_power: Boolean,
    bolla_dettaglio: { type: Number, default: null },
    synch_dettaglio: { type: Number, default: 0 },
    value: Array,
  },
  computed: {
    data_scadenza_formattata() {
      return this.dialog_buffer.data_scadenza != null &&
        this.dialog_buffer.data_scadenza != ""
        ? moment(this.dialog_buffer.data_scadenza).format("DD-MM-YYYY")
        : "";
    },
    computed_bolla_dettaglio() {
      if (this.new_bolla_dettaglio == null) {
        return this.bolla_dettaglio;
      } else {
        return this.new_bolla_dettaglio;
      }
    },
  },
  data() {
    return {
      key_segnalazioni: 0,
      allegati_documento: new Array(),
      qr_attivo: false,
      articoli_search: "",
      modalita_stampa: "filtro",
      calendario_data_scadenza: false,
      dialog_segnalazioni: false,
      dialog_clonazione: false,
      dialog_lotto_fornitore: false,
      dialog_riepilogo: false,
      dialog_allegato_documento: false,
      dialog_allegato_riga: false,
      dialog_preview: false,
      overlay_etichette: false,
      conferma_stampa_visible: false,
      new_bolla_dettaglio: null,
      qtaDisp: null,
      id_articolo_mass_sel: null,
      id_ordine_mass_sel: null,
      is_ingresso_from_ordine: false,
      itemTmp: null,
      iframeUrl: "",
      key_lotto_tabella: 0,
      lista_um: [],
      headers_art_mass: [
        { text: "Seleziona", value: "seleziona", width: "150px" },
        { text: "Codice Articolo", value: "cod_articolo", align: "start" },
        { text: "Descrizione", value: "descrizione" },
        { text: "Numero Colli", value: "num_colli" },
        { text: "Quantità", value: "quantita" },
        { text: "Unità di Misura", value: "um" },
        { text: "Riga Ordine", value: "riga_ordine" },
        { text: "Data Documento", value: "DATA_DOCUMENTO" },
        { text: "Data Consegna", value: "DATA_CONSEGNA" },
      ],
      headers_art_mass_art: [
        { text: "Seleziona", value: "seleziona", width: "150px" },
        { text: "Num. Ordine", value: "NUM_ORDINE", align: "start" },
        { text: "Codice Articolo", value: "COD_ARTICOLO", align: "start" },
        { text: "Descrizione", value: "descrizione" },
        { text: "Quantità", value: "QUANTITA" },
        { text: "Unità di Misura", value: "um" },
        { text: "Riga Ordine", value: "RIGA_ORDINE" },
        { text: "Data Documento", value: "DATA_DOCUMENTO" },
        { text: "Data Consegna", value: "DATA_CONSEGNA" },
      ],
      items_magazzini: new Array(),
      items_art_mass: new Array(),
      items_art_mass_art: new Array(),
      items_select_ord_mass: new Array(),
      items_select_art_mass_art: new Array(),
      items_um: new Array(),
      items_um_peso: new Array(),
      items_riepilogo: [],
      array_ordini_quantita: [],
      array_tmp_ord_qnt: [],
      etichette: [],
      ordine_tmp: null,
      codice_fornitore_sel: null,
      caricamento: false,
      qr_code_sel: "",
      riga_sel: { id_documento_dettaglio: null, lotto_fornitore: "" },
      riga_clone: new Object(),
      snackbar: false,
      snackbar_background: "",
      snackbar_icon: "",
      snackbar_icon_color: "",
      snackbar_text: "",
      snackbar_text_color: "",
      ricerca_anagrafica: null,
      ragioneSocialeLista: [],
      ordini_originali: [],
      ragioneSociale: [
        { text: null, value: null, align: "start" },
        { text: "Ragione Sociale", value: "ragione_sociale" },
        { text: "Cod. Fornitore", value: "codice" },
        { text: "Indrizzo", value: "indirizzo" },
      ],
      dialogConfReg: false,
      dialogSearchAnagrafica: false,
      dialog_selezione_massiva_articolo: false,
      dialog_selezione_massiva_fornitore: false,
      dialog_lista_ordini: false,
      dialog_conferma_ordine: false,
      riga_count: 1,
      dettaglio: {
        cod_anagrafica: null,
        cod_documento: "DDTR",
        data_documento: moment().format("YYYY-MM-DD"),
        dettaglio: [],
        id_anagrafica: null,
        id_documento: -1,
        id_documento_tmp: moment().valueOf(),
        num_documento: null,
        ragione_sociale: null,
        tipo_soggetto: null,
        validita: 1,
      },
      dialog_buffer: {
        id_documento_dettaglio: -1,
        id_documento_dettaglio_tmp: null,
        id_documento: -1,
        id_articolo: null,
        id_magazzino: null,
        descrizione: null,
        cod_articolo: null,
        data_consegna: null,
        data_scadenza: null,
        data_documento: null,
        note_riga: "",
        peso_unitario: null,
        id_um: null,
        um: null,
        quantita: null,
        num_colli: 1,
        seriale: null,
        gestione_lotto: 0,
        lotto_fornitore: null,
        peso_netto: null,
        peso_lordo: null,
        um_peso: null,
        ricezione_peso_lordo: 0,
        ricezione_peso_netto: 0,
        cod_lotto: null,
        num_riga: null,
        prezzo_totale: 0,
        stato_riga: null,
        num_ordine: null,
        riga_ordine: null,
        qta_per_collo: true,
        allegati: [],
        validita: 1,
      },
      dialog_inserimento: {
        indice: -1,
        mostra: false,
      },
      dialog_lista: {
        caricamento: false,
        mostra: false,
        ricerca: null,
        tabella: {
          testata: [
            { text: null, value: null, align: "start" },
            { text: "Codice Articolo", value: "cod_articolo" },
            { text: "Descrizione Articolo", value: "des_articolo" },
          ],
          dati: [],
        },
      },
      regole: {
        no_null_str: [
          (valore) =>
            (valore != null && valore != undefined
              ? valore.toString().length > 0
              : false) || "Campo obbligatorio",
        ],
        no_null_num: [
          (valore) =>
            (valore != null &&
              valore != undefined &&
              !isNaN(valore) &&
              valore > 0) ||
            "Campo obbligatorio",
        ],
      },
      tabella: {
        testata: [
          { text: "Modifica", value: null, sortable: false },
          { text: "Duplica", value: null, sortable: false },
          { text: "N. Pallet", value: "n_pallet", sortable: false },
          { text: "Codice Articolo", value: "cod_articolo", align: "start" },
          { text: "Numero seriale", value: "seriale", align: "start" },
          { text: "Descrizione", value: "descrizione" },
          { text: "Numero Colli", value: "num_colli" },
          { text: "Unità di Misura", value: "um" },
          { text: "Lotto Fornitore", value: "lotto_fornitore" },
          { text: "Quantità", value: "quantita" },
          { text: "Lotto Assegnato", value: "cod_lotto" },
          { text: "Rif. Ordine", value: "num_ordine" },
          { text: "Riga Ordine", value: "riga_ordine" },
          { text: "Stampa", value: null, sortable: false },
          { text: "Allegati", value: null, sortable: false },
          { text: "Segnalazioni", value: null, sortable: false },
          { text: "Eliminazione", value: null, sortable: false },
        ],
        testata_riepilogo: [
          { text: "Codice Articolo", value: "cod_articolo", align: "start" },
          { text: "Numero Colli", value: "colli" },
          { text: "Quantità", value: "quantita" },
        ],
        dati: [],
      },
      tabellaOrdini: {
        testata: [
          { text: null, value: null },
          { text: "Numero Ordine", value: "NUM_ORDINE", align: "start" },
          { text: "Cod. Articolo", value: "COD_ARTICOLO" },
          { text: "Des. Articolo", value: "descrizione" },
          { text: "Num. Seriale", value: "NUM_SERIALE" },
          { text: "Data Documento", value: "DATA_DOCUMENTO" },
          { text: "Data Consegna", value: "DATA_CONSEGNA" },
          { text: "Quantità residua", value: "QUANTITA" },
        ],
        dati: [],
      },
      headersConf: [
        { text: "Numero Ordine", value: "NUM_ORDINE" },
        { text: "Cod. Articolo", value: "COD_ARTICOLO" },
        { text: "Data Documento", value: "DATA_DOCUMENTO" },
        { text: "Data Consegna", value: "DATA_CONSEGNA" },
        { text: "Quantità", value: "QUANTITA" },
      ],
      items_articoli: [],
      input_args: {
        clear_on_save: true,
        cod_articolo: "",
        cod_documento: "",
        data_documento: "",
        destinazione: "",
        disegni_iniziali: [],
        id_articolo: 0,
        immagine_standard_editor: "",
        num_documento: "",
        riferimento: 0,
        return_array: true,
        show_close_button: true,
        show_editor_arrow_button: true,
        show_editor_camera_button: true,
        show_editor_circle_button: true,
        show_editor_color_picker_button: true,
        show_editor_crop_button: true,
        show_editor_edit_back_button: true,
        show_editor_edit_forward_button: true,
        show_editor_eraser_button: true,
        show_editor_free_draw_button: true,
        show_editor_large_size_button: true,
        show_editor_letter_case_button: true,
        show_editor_medium_size_button: true,
        show_editor_save_button: true,
        show_editor_small_size_button: true,
        show_editor_square_button: true,
        show_editor_tool_columns: true,
        show_editor_upload_button: true,
        tabella_supporto: "disegno",
        titolo_editor: "Editor",
        visible: true,
      },
    };
  },
  watch: {
    computed_bolla_dettaglio: {
      immediate: true,
      handler() {
        if (this.computed_bolla_dettaglio != null) {
          this.getDocumento();
        }
      },
    },
    codice_fornitore_sel: {
      immediate: true,
      handler() {
        if (
          !this.tabellaOrdini.dati.length &&
          this.codice_fornitore_sel != null &&
          this.synch_dettaglio != 1
        ) {
          this.getOrdini();
        }
      },
    },
    "dialog_buffer.quantita": {
      immediate: true,
      handler() {
        /* Se l'articolo è marcato con ricezione in
         * peso netto o peso lordo, aggiorno i campi
         * di input relativi. */
        if (this.dialog_buffer.ricezione_peso_netto == 1) {
          this.dialog_buffer.peso_netto = this.dialog_buffer.quantita;
        } else if (this.dialog_buffer.ricezione_peso_lordo == 1) {
          this.dialog_buffer.peso_lordo = this.dialog_buffer.quantita;
        }
      },
    },
  },
  mounted() {
    // Faccio una chiamata per prendere le unità di misura dei pesi.
    this.gettabelle();
    this.getMagazzini();
  },
  methods: {
    checkQrCode(arg) {
      const request = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "checkbobinaddtold",
          token: localStorage.user_token,
          qrcode: arg,
        },
      };

      return this.$store
        .dispatch("api", request)
        .then((res) => {
          if (res.status === 200) {
            return res.data.result;
          } else {
            this.$refs.SnackbarQV.print(
              "error",
              `Criticità rilevata, non è stato possibile caricare i dati; codice errore: ${res.status}.`
            );
          }
        })
        .catch((err) => {
          this.overlay = false;
          this.$refs.SnackbarQV.print(
            "orange",
            `${JSON.parse(err.response.data.message).result}.`
          );
        });
    },
    clonaRiga(arg) {
      let index = -1;
      for (let i = 0; i < this.tabella.dati.length; i++) {
        if (
          this.tabella.dati[i].id_documento_dettaglio ===
          arg.id_documento_dettaglio
        ) {
          index = i;
        }
      }

      /* Ricavo la quantità massima che posso
       * registrare per questo articolo in base
       * al suo ordine di riferimento. */
      let qnt_max_in_ordine = 0;
      this.items_articoli.forEach((a) => {
        if (
          a.NUM_ORDINE == arg.num_ordine &&
          a.COD_ARTICOLO == arg.cod_articolo
        ) {
          qnt_max_in_ordine = a.QUANTITA;
        }
      });

      this.riga_clone = JSON.parse(JSON.stringify(arg));
      this.riga_clone.id_documento_dettaglio = -moment().valueOf();
      this.riga_clone.id_documento_dettaglio_tmp = -moment().valueOf();
      this.riga_clone.id_documento = -1;
      this.riga_clone.quantita_max_prelevabile = qnt_max_in_ordine;
      this.riga_clone.quantita = 0;
      this.riga_clone.lotto_fornitore = "";
      this.riga_clone.peso_netto = null;
      this.riga_clone.peso_lordo = null;
      this.riga_clone.um_peso = null;
      this.riga_clone.ricezione_peso_netto = null;
      this.riga_clone.ricezione_peso_lordo = null;
      this.riga_clone.index = index;

      this.dialog_clonazione = true;
    },
    closeAllegatoDocumento() {
      this.dialog_allegato_documento = false;
    },
    closeAllegatoRiga() {
      this.dialog_allegato_riga = false;
    },
    confermaDuplicaRiga() {
      // Controllo la quantità.
      if (this.riga_clone.quantita > this.riga_clone.quantita_max_prelevabile) {
        this.$refs.SnackbarQV.print(
          "orange",
          `Quantità ordine eccedente: max ${this.riga_clone.quantita_max_prelevabile}.`
        );
        return;
      }

      /* Controllo che la coppia codice lotto fornitore - numero seriale
       * non ricorra per nessuna delle righe già registrate per un oggetto nuovo.*/
      let ricorre = false;
      this.tabella.dati.forEach((e) => {
        if (
          e.seriale === this.riga_clone.seriale &&
          e.lotto_fornitore === this.riga_clone.lotto_fornitore
        ) {
          ricorre = true;
        }
      });

      if (ricorre == true) {
        this.$refs.SnackbarQV.print("orange", "Codice lotto già presente.");
        return;
      }

      const index = this.riga_clone.index;
      delete this.riga_clone.index;

      const obj_tmp = JSON.parse(JSON.stringify(this.riga_clone));

      /* Aggiorno le tabelle degli ordini in items_articoli
       * e in tabellaOrdini.dati in modo che i dati visualizzati
       * siano aggiornati. */

      // Calcolo la quantità ancora disponibile.
      let quantita_ancora_disponibile = this.items_articoli.filter(
        (a) =>
          a.NUM_ORDINE == this.riga_clone.num_ordine &&
          a.COD_ARTICOLO == this.riga_clone.cod_articolo
      )[0].QUANTITA;

      /* Calcolo la quantità che vorrei ancora prelevare
       * (questo calcolo tiene conto del fatto che magari
       * sto modificando una riga già esistente e potrei
       * anche stare riducendo la quantità del prelievo.)*/
      const riga_gia_inserita = this.tabella.dati.filter(
        (a) =>
          a.id_documento_dettaglio == this.riga_clone.id_documento_dettaglio
      );

      let quantita_da_prelevare =
        riga_gia_inserita.length > 0
          ? riga_gia_inserita[0].quantita - this.riga_clone.quantita
          : -this.riga_clone.quantita;

      /* Se la quantità di articolo ancora disponibile meno
       * la quantità che vorrei prelevare è < 0, non prelevo;
       * altrimenti prelevo e sottraggo la quantità che voglio
       * prelevare alla quantità ancora prelevabile. Questa
       * operazione, per via dei passaggi precedenti, non si
       * rompe se una riga già esistente sta venendo modificata. */
      if (quantita_ancora_disponibile + quantita_da_prelevare < 0) {
        this.$refs.SnackbarQV.print(
          "orange",
          `Prelievo eccessivo: max ${
            riga_gia_inserita.length > 0
              ? riga_gia_inserita[0].quantita + quantita_ancora_disponibile
              : quantita_ancora_disponibile
          }`
        );
        return;
      } else {
        this.items_articoli.filter(
          (a) =>
            a.NUM_ORDINE == this.riga_clone.num_ordine &&
            a.COD_ARTICOLO == this.riga_clone.cod_articolo
        )[0].QUANTITA += quantita_da_prelevare;
      }

      this.tabella.dati.splice(index, 0, obj_tmp);
      this.dialog_clonazione = false;
    },
    confermaLottoFornitore() {
      // Controllo che il lotto fornitore sia presente se richiesto.
      if (
        this.riga_sel.lotto_fornitore == null ||
        this.riga_sel.lotto_fornitore === ""
      ) {
        this.$refs.SnackbarQV.print(
          "orange",
          "Il lotto fornitore è obbligatorio per questo articolo."
        );
        return;
      }

      this.tabella.dati.forEach((d) => {
        if (d.id_documento_dettaglio == this.riga_sel.id_documento_dettaglio) {
          this.$set(d, "lotto_fornitore", this.riga_sel.lotto_fornitore);
        }
      });

      this.dialog_lotto_fornitore = false;
      this.key_lotto_tabella = this.key_tabella === 0 ? 1 : 0;
      this.$forceUpdate();
    },
    editLottoFornitore(arg) {
      // Registro i dati che mi interessano della riga cliccata.
      this.riga_sel.id_documento_dettaglio = arg.id_documento_dettaglio;
      this.riga_sel.lotto_fornitore = arg.lotto_fornitore;

      // Apro il dialog di modifica.
      this.dialog_lotto_fornitore = true;
    },
    eliminaFiltro() {
      this.articoli_search = "";
      this.items_articoli = Array.from(this.tabellaOrdini.dati);
    },
    gettabelle() {
      const request = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "gettabelle",
          token: localStorage.user_token,
          tipo: "UNITA_MISURA",
          filter: "validita = 1",
        },
      };

      return this.$store
        .dispatch("api", request)
        .then((res) => {
          if (res.status === 200) {
            if (res.data) {
              this.items_um = res.data;
              this.items_um_peso = res.data.filter((e) => e.val_txt == "P");
            } else {
              this.items_um_peso = new Array();
            }
            return true;
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non è stato possibile caricare i dati."
            );
            return false;
          }
        })
        .catch((err) => {
          console.error(err);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, non è stato possibile caricare i dati."
          );
          return false;
        });
    },
    filtra() {
      let items_articoli_tmp = [];
      this.items_articoli.forEach((elem) => {
        items_articoli_tmp.push(elem);
      });

      if (this.articoli_search != "") {
        // Faccio un array temporaneo
        let res = [];

        // Filtro gli elementi visualizzati dopo i passaggi precedenti
        items_articoli_tmp.forEach((elem) => {
          if (elem.COD_ARTICOLO == this.articoli_search) {
            res.push(elem);
          }
        });

        items_articoli_tmp = res;
      }

      this.items_articoli = [];
      this.items_articoli = items_articoli_tmp;
    },
    popolaRiepilogo() {
      const array_tmp = new Array();

      this.tabella.dati.forEach((e) => {
        let ricorre = false;

        array_tmp.forEach((f) => {
          if (e.cod_articolo === f.cod_articolo) {
            ricorre = true;
          }
        });

        if (ricorre === false) {
          let colli = 0;
          let quantita = 0;

          this.tabella.dati.forEach((f) => {
            if (e.cod_articolo === f.cod_articolo && f.validita != 0) {
              colli += f.num_colli;
              quantita = parseInt(quantita) + parseInt(f.quantita);
            }
          });

          array_tmp.push({
            cod_articolo: e.cod_articolo,
            colli: colli,
            quantita: quantita,
          });
        }
      });

      return array_tmp;
    },
    confermaRegMultiRiga() {
      this.array_tmp_ord_qnt.forEach((elem, index) => {
        let clone = Object.assign({}, this.dialog_buffer);
        clone.validita = 1;
        clone.id_documento_dettaglio =
          -moment().valueOf() - this.tabella.dati.length;
        clone.id_documento_dettaglio_tmp = clone.id_documento_dettaglio;
        clone.id_documento = -1;
        clone.num_riga = index + 1;
        clone.riga_ordine = elem.RIGA_ORDINE;
        clone.num_ordine = elem.NUM_ORDINE;
        clone.quantita = elem.QUANTITA;
        this.tabella.dati.push(clone);
      });

      this.tabella.dati.forEach((ordine_tbl) => {
        let qta_ordine_utile = ordine_tbl.quantita;
        this.tabellaOrdini.dati.forEach((ordine) => {
          if (
            ordine_tbl.riga_ordine == ordine.RIGA_ORDINE &&
            ordine_tbl.validita != 0 &&
            qta_ordine_utile > 0 &&
            ordine.QUANTITA + 500 > ordine_tbl.quantita &&
            ordine_tbl.data_consegna == ordine.DATA_CONSEGNA &&
            ordine_tbl.data_documento == ordine.DATA_DOCUMENTO
          ) {
            ordine.QUANTITA = ordine.QUANTITA - ordine_tbl.quantita;
            qta_ordine_utile = qta_ordine_utile - qta_ordine_utile;
          }
        });
      });

      this.items_articoli = this.tabellaOrdini.dati;

      this.array_tmp_ord_qnt = [];
      this.array_ordini_quantita = [];
      this.qtaDisp = null;
      this.dialogConfReg = false;
    },
    chiudiDialogConfermaReg() {
      this.array_tmp_ord_qnt = [];
      this.array_ordini_quantita = [];
      this.qtaDisp = null;
      this.dialogConfReg = false;
    },
    annullaSelezioneOrdine() {
      this.ordine_tmp = null;
      this.dialog_conferma_ordine = false;
    },
    backFromListaOrdini() {
      this.dialog_lista_ordini = false;
    },
    selezionaOrdine(ordine_tmp, seriale, qta, lotto_fornitore) {
      /* Se l'articolo che sto salvando arriva da
       * una selezione massiva, ci pensa un altro
       * metodo a controllare che ci sia un magazzino
       * predefinito. Se invece sto salvando una riga
       * singola, controllo che abbia effettivamente un
       * magazzino predefinito. */
      if (
        ordine_tmp.articolo_massivo == 0 &&
        (ordine_tmp.id_magazzino == null || ordine_tmp.id_magazzino == "")
      ) {
        this.$refs.SnackbarQV.print(
          "orange",
          `Impossibile eseguire il salvataggio: l'articolo ${ordine_tmp.COD_ARTICOLO} non ha un magazzino predefinito.`
        );
        return;
      }

      // Eseguo la logica di salvataggio.
      this.qtaDisp = null;

      this.dialog_buffer.descrizione = ordine_tmp.descrizione;
      this.dialog_buffer.um = ordine_tmp.um;
      this.dialog_buffer.num_ordine = ordine_tmp.NUM_ORDINE;
      this.dialog_buffer.id_documento_rif = ordine_tmp.id_documento_rif;
      this.dialog_buffer.id_documento_dettaglio_rif =
        ordine_tmp.id_documento_dettaglio_rif;
      this.dialog_buffer.riga_ordine = ordine_tmp.RIGA_ORDINE;
      this.dialog_buffer.cod_articolo = ordine_tmp.COD_ARTICOLO;
      this.dialog_buffer.data_consegna = ordine_tmp.DATA_CONSEGNA;
      this.dialog_buffer.data_documento = ordine_tmp.DATA_DOCUMENTO;
      this.dialog_buffer.quantita = qta ? qta : ordine_tmp.QUANTITA;
      this.dialog_buffer.seriale = seriale;
      this.dialog_buffer.lotto_fornitore = lotto_fornitore;
      this.dialog_buffer.id_magazzino = ordine_tmp.id_magazzino;
      this.dialog_buffer.quantita_max_prelevabile = ordine_tmp.QUANTITA;

      // passo le informazioni dell ordine(item) nell'articolo
      this.array_ordini_quantita = [];
      this.tabellaOrdini.dati.forEach((elem) => {
        if (elem.COD_ARTICOLO === ordine_tmp.COD_ARTICOLO) {
          this.array_ordini_quantita.push(elem);
        }
      });

      this.dialog_conferma_ordine = false;
      this.dialog_lista_ordini = false;

      // alla fine svuoto ordine_tmp
      this.ordine_tmp = null;
      // this.tabellaOrdini.dati = [];

      // this.dialog_inserimento.mostra = true;
      this.is_ingresso_from_ordine = true;
      this.salvaModifiche();
    },
    clickAggiungiSegnalazione(arg_pk, arg_id, arg_riferimento, arg) {
      this.input_args.id_riferimento = arg_id;
      this.input_args.pk_riferimento = arg_pk;
      this.input_args.riferimento = arg_riferimento;
      this.input_args.cod_documento = arg.cod_documento;
      this.input_args.num_documento = arg.num_documento;
      this.input_args.cod_articolo = arg.cod_articolo;
      this.input_args.data_documento = moment().format("YYYY-MM-DD HH:mm:ss");
      this.dialog_segnalazioni = true;
      this.key_segnalazioni = this.key_segnalazioni === 0 ? 1 : 0;
    },
    clickDialogOrdini() {
      // chiamo la get ordini e popolo l'array che mi servira per
      // visualizzare la lista degli ordini

      // this.getOrdini();
      // this.caricamento = true;

      this.dialog_lista_ordini = true;
    },
    clickItemListaOrdini(item) {
      if (item.QUANTITA < 0) {
        this.snackbar = true;
        this.snackbar_background = "error";
        this.snackbar_text =
          "Quantità ordine negativa, Impossibile aggiungere l'articolo!";
        this.snackbar_icon = "mdi-close-outline";
        this.snackbar_text_color = "white";
        this.snackbar_icon_color = "white";
        return;
      }
      this.ordine_tmp = Object.assign({}, item);
      // QUI
      let request = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getarticoli",
          token: localStorage.getItem("user_token"),
          cod_articolo: this.ordine_tmp.COD_ARTICOLO,
        },
      };
      this.$store
        .dispatch("api", request)
        .then((res) => {
          if (res.status === 200) {
            this.dialog_buffer.id_articolo = res.data.lista[0].id_articolo;
            this.dialog_buffer.gestione_lotto = item.gestione_lotto;
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicaizone col server, non è stato possibile caricare i dati."
            );
          }
        })
        .catch((e) => {
          console.error(e);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicaizone col server, non è stato possibile caricare i dati."
          );
        });
      this.dialog_conferma_ordine = true;
    },
    chiudiDialogPreview() {
      this.dialog_preview = false;
    },
    chiudiDialogRicercaArt() {
      this.dialog_lista.mostra = false;
      this.dialog_lista.ricerca = null;
    },
    chiudiDialogRicercaFornitore() {
      this.dialogSearchAnagrafica = false;
      this.ricerca_anagrafica = null;
    },
    closeSegnalazioni() {
      this.dialog_segnalazioni = false;
    },
    detectQrCode(arg) {
      this.qr_code_sel = arg;
      this.qr_attivo = true;

      if (this.qr_code_sel) {
        this.getQr(this.qr_code_sel);
      }
    },
    detectQrCodeFornitore(arg) {
      // Se non c'è l'intestazione giusta stampo un errore
      if (arg.split(";")[0].includes("GETQRCPS") === false) {
        this.$refs.SnackbarQV.print(
          "orange",
          "Il QR code non è conforme, impossibile acquisire i dati."
        );
        return;
      }

      // Se l'intestazion è giusta e il testo contiene un cmapo (V)...
      if (arg.includes("(V)")) {
        // Valorizzo le variabili di supporto come mi interessa
        this.dettaglio.ragione_sociale = "";
        this.codice_fornitore_sel = arg.split("(V)")[1].split(";")[0];

        /* Faccio una chiamata per avere i dati dei fornitori
         * con questo codice, in particolare mi interessano le
         * loro ragioni sociali per valorizzare il campo di input. */
        let searchReq = {
          controller: "Magazzino",
          method: "POST",
          richiesta: {
            action: "getragionesociale",
            token: localStorage.getItem("user_token"),
            // cod_anagrafica: this.cod_anagrafica,
            cod_anagrafica: this.codice_fornitore_sel,
            tipo_anagrafica: "F",
          },
        };

        // Metto un overlay di caricamento
        this.caricamento = true;
        this.$store
          .dispatch("api", searchReq)
          .then((res) => {
            if (res.status === 200) {
              // Fermo l'overlay di caricamento
              this.caricamento = false;

              // Valorizzo il text field della ragione sociale del fornitore
              this.dettaglio.ragione_sociale = res.data[0].ragione_sociale;
              this.dettaglio.cod_anagrafica = res.data[0].cod_fornitore;

              /* Eseguo anche la funzione getOrdini per avere
               * gli ordini associati a questo fornitore. */
              this.getOrdini();
            } else {
              this.$refs.SnackbarQV.print(
                "orange",
                "Errore nel recupero dati del fornitore."
              );
            }
          })
          .catch(() => {
            this.$refs.SnackbarQV.print(
              "error",
              "Errore nel recupero dati del fornitore."
            );
          });
      } else {
        this.$refs.SnackbarQV.print(
          "orange",
          "Impossibile rilevare un Cod. Fornitore nel codice scansionato."
        );
      }
    },
    eliminaRiga(riga) {
      riga.validita = 0;

      // Riprisrtino le quantità nell'array degli ordini
      const ordini_abbassati = Array.from(
        this.items_articoli.filter((e) => e.COD_ARTICOLO === riga.cod_articolo)
      );
      const ordini_originali = Array.from(
        this.ordini_originali.filter(
          (e) => e.COD_ARTICOLO === riga.cod_articolo
        )
      );

      /* Ho gli ordini interessati, le loro quantità originali e attuali.
       * Ora ciclo per ripristinare le quantità originali. */
      let quantita_limite = riga.quantita;

      for (let i = 0; i < ordini_abbassati.length; i++) {
        for (let j = 0; j < ordini_originali.length; j++) {
          if (
            ordini_abbassati[i].NUM_ORDINE === ordini_originali[j].NUM_ORDINE &&
            ordini_abbassati[i].RIGA_ORDINE ===
              ordini_originali[j].RIGA_ORDINE &&
            ordini_abbassati[i].DATA_DOCUMENTO ===
              ordini_originali[j].DATA_DOCUMENTO &&
            ordini_abbassati[i].DATA_CONSEGNA ===
              ordini_originali[j].DATA_CONSEGNA &&
            ordini_abbassati[i].QUANTITA < ordini_originali[j].QUANTITA &&
            quantita_limite > 0
          ) {
            ordini_abbassati[i].QUANTITA +=
              ordini_originali[j].QUANTITA < quantita_limite
                ? ordini_originali[j].QUANTITA
                : quantita_limite;
            if (ordini_originali[j].QUANTITA < quantita_limite) {
              quantita_limite -= ordini_originali[j].QUANTITA;
            } else {
              quantita_limite = 0;
            }
          }
        }
      }

      // Applico le modifiche al'array reale
      for (let i = 0; i < ordini_abbassati.length; i++) {
        for (let j = 0; j < this.items_articoli.length; j++) {
          if (
            ordini_abbassati[i].NUM_ORDINE ===
              this.items_articoli[j].NUM_ORDINE &&
            ordini_abbassati[i].RIGA_ORDINE ===
              this.items_articoli[j].RIGA_ORDINE &&
            ordini_abbassati[i].DATA_DOCUMENTO ===
              this.items_articoli[j].DATA_DOCUMENTO &&
            ordini_abbassati[i].DATA_CONSEGNA ===
              this.items_articoli[j].DATA_CONSEGNA
          ) {
            this.items_articoli[j].QUANTITA = ordini_abbassati[i].QUANTITA;
          }
        }
      }

      for (let i = 0; i < ordini_abbassati.length; i++) {
        for (let j = 0; j < this.tabellaOrdini.dati.length; j++) {
          if (
            ordini_abbassati[i].NUM_ORDINE ===
              this.tabellaOrdini.dati[j].NUM_ORDINE &&
            ordini_abbassati[i].RIGA_ORDINE ===
              this.tabellaOrdini.dati[j].RIGA_ORDINE &&
            ordini_abbassati[i].DATA_DOCUMENTO ===
              this.tabellaOrdini.dati[j].DATA_DOCUMENTO &&
            ordini_abbassati[i].DATA_CONSEGNA ===
              this.tabellaOrdini.dati[j].DATA_CONSEGNA
          ) {
            this.tabellaOrdini.dati[j].QUANTITA = ordini_abbassati[i].QUANTITA;
          }
        }
      }
    },
    getMagazzini() {
      let request = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getmagazzini",
          token: localStorage.getItem("user_token"),
        },
      };

      this.$store
        .dispatch("api", request)
        .then((res) => {
          if (res.status == 200) {
            res.data.forEach((e) => {
              e.des_magazzino = `${e.cod_magazzino} - ${e.des_magazzino}`;
              this.items_magazzini.push(e);
            });
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non è stato possibile caricare i dati."
            );
          }
        })
        .catch((err) => {
          console.error(err);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, non è stato possibile caricare i dati."
          );
        });
    },

    /* DIALOG */
    mostraDialog(riga, clona = false) {
      let indice = this.tabella.dati.indexOf(riga);
      this.dialog_inserimento.indice = indice;
      let campi = Object.keys(this.dialog_buffer);
      for (let i = 0; i < campi.length; i++) {
        if (campi[i] === "num_colli") {
          this.dialog_buffer["num_colli"] = 1;
        } else if (campi[i] === "prezzo_totale") {
          if (riga == null) {
            this.dialog_buffer["prezzo_totale"] = (0).toFixed(3);
          } else if (
            riga[campi[i]] == "NaN" ||
            riga[campi[i]] == "" ||
            riga[campi[i]] == null
          ) {
            this.dialog_buffer["prezzo_totale"] = (0).toFixed(3);
          } else {
            this.dialog_buffer["prezzo_totale"] = parseFloat(riga[campi[i]]).toFixed(3);
          }
        } else {
          this.dialog_buffer[campi[i]] = indice >= 0 ? riga[campi[i]] : null;
        }
      }

      /* Se sto aggiungendo una nuova riga la
       * qta_per_collo deve essere valorizzata
       * con true. */
      if (indice < 0) {
        this.dialog_buffer.qta_per_collo = true;
      }

      if (riga != null) {
        // Aggiorno la quantità massima prelevabile, che potrebbe essere cambiata.
        this.items_articoli.forEach((a) => {
          if (
            a.NUM_ORDINE == riga.num_ordine &&
            a.COD_ARTICOLO == riga.cod_articolo
          ) {
            this.dialog_buffer.quantita_max_prelevabile = a.QUANTITA;
          }
        });
      }

      this.dialog_inserimento.mostra = true;

      if (clona) {
        this.dialog_inserimento.indice = -1;
      }
      let that = this;
      this.$nextTick(function () {
        that.$refs.form.resetValidation();
      });
    },
    ripristinaRiga(riga) {
      // this.dialog_inserimento.indice = riga.riga_ordine - 1;
      riga.validita = 1;

      // for (let key in this.dialog_buffer) {
      //   if (riga[key]) {
      //     this.dialog_buffer[key] = riga[key];
      //   }
      // }

      // this.salvaModifiche();
    },
    salvataggioMassivoArticolo() {
      this.items_art_mass_art
        .filter((e) => e.selezionato == 1)
        .forEach((e, index) => {
          // Mi costruisco un oggetto da aggiungere alle righe del documento.
          const obj_tmp = new Object();
          obj_tmp.id_documento_dettaglio =
            -moment().valueOf() - this.tabella.dati.length;
          obj_tmp.id_documento_dettaglio_tmp = e.id_documento_dettaglio;
          obj_tmp.id_documento = -1;
          obj_tmp.id_articolo = e.id_articolo;
          obj_tmp.descrizione = e.descrizione;
          obj_tmp.cod_articolo = e.COD_ARTICOLO;
          obj_tmp.data_consegna = e.DATA_CONSEGNA;
          obj_tmp.data_documento = e.DATA_DOCUMENTO;
          obj_tmp.peso_unitario = null;
          obj_tmp.id_um = e.id_um;
          obj_tmp.um = e.um;
          obj_tmp.quantita = e.QUANTITA;
          obj_tmp.peso_netto = e.ricezione_peso_netto == 1 ? e.QUANTITA : null;
          obj_tmp.peso_lordo = e.ricezione_peso_lordo == 1 ? e.QUANTITA : null;
          obj_tmp.um_peso =
            e.ricezione_peso_netto == 1 || e.ricezione_peso_lordo == 1
              ? e.id_um
              : null;
          obj_tmp.ricezione_peso_netto = e.ricezione_peso_netto;
          obj_tmp.ricezione_peso_lordo = e.ricezione_peso_lordo;
          obj_tmp.num_colli = 1;
          obj_tmp.gestione_lotto = e.gestione_lotto;
          obj_tmp.lotto_fornitore = "";
          obj_tmp.cod_lotto = null;
          obj_tmp.num_riga = index + 1;
          obj_tmp.stato_riga = null;
          obj_tmp.num_ordine = e.NUM_ORDINE;
          obj_tmp.riga_ordine = e.RIGA_ORDINE;
          obj_tmp.qta_per_collo = true;
          obj_tmp.allegati = new Array();
          obj_tmp.validita = 1;
          obj_tmp.id_documento_rif = e.id_documento_rif;
          obj_tmp.id_documento_dettaglio_rif = e.id_documento_dettaglio_rif;
          obj_tmp.id_magazzino = e.id_magazzino;
          obj_tmp.quantita_max_prelevabile = e.quantita_max_prelevabile;
          obj_tmp.qr_encoded = 0;
          obj_tmp.residuo = 0;

          /* Ora che ho finito di usare le varie quantità, azzero la quantità
           * massima prelevabile per l'articolo di riferimento sia nell array
           * temporaneo della tabella, che è il risultato di un filtro, sia
           * nell'array sorgente principale. */
          e.QUANTITA = 0;
          e.quantita_max_prelevabile = 0;

          this.items_articoli.filter(
            (a) =>
              a.NUM_ORDINE == e.NUM_ORDINE && a.COD_ARTICOLO == e.COD_ARTICOLO
          )[0].quantita_max_prelevabile = 0;
          this.items_articoli.filter(
            (a) =>
              a.NUM_ORDINE == e.NUM_ORDINE && a.COD_ARTICOLO == e.COD_ARTICOLO
          )[0].QUANTITA = 0;

          // Aggiungo un prezzo fittizio.
          obj_tmp.prezzo_totale =
            parseFloat(obj_tmp.prezzo_totale).toFixed(3) ?? (0).toFixed(3);

          // Aggiungo l'oggetto alla riga del documento.
          this.tabella.dati.push(obj_tmp);
        });
      this.$refs.SnackbarQV.print(
        "success",
        "Gli articoli selezionati sono stati aggiunti al documento."
      );
    },
    selezionaAnagrafica(fornitore) {
      this.dettaglio.tipo_soggetto = fornitore.tipo;
      this.dettaglio.id_anagrafica = fornitore.id_anagrafica;
      this.dettaglio.ragione_sociale = fornitore.ragione_sociale;
      this.dettaglio.cod_anagrafica = fornitore.codice;
      this.codice_fornitore_sel = fornitore.codice;
      this.dialogSearchAnagrafica = false;
      // REGISTRO GLI ORDINI RELATIVI AL FORNITORE
      this.getOrdini();
    },
    selezionaArticolo(articolo) {
      /* Se sono entrato in questo metodo è perché
       * non sto prelevando da un ordine e quindi metto
       * a false il flag relativo. */
      this.is_ingresso_from_ordine = false;

      this.dialog_buffer.cod_articolo = articolo.cod_articolo;
      this.dialog_buffer.id_articolo = articolo.id_articolo;
      this.dialog_buffer.id_magazzino = articolo.id_magazzino;
      this.dialog_buffer.um = articolo.des_um;
      this.dialog_buffer.id_um = articolo.id_um;
      this.dialog_buffer.descrizione = articolo.des_articolo;
      this.dialog_buffer.gestione_lotto = articolo.gestione_lotto;
      this.dialog_buffer.ricezione_peso_netto = articolo.ricezione_peso_netto;
      this.dialog_buffer.ricezione_peso_lordo = articolo.ricezione_peso_lordo;
      this.dialog_buffer.um_peso =
        (articolo.ricezione_peso_netto == 1 ||
          articolo.ricezione_peso_lordo == 1) &&
        this.items_um_peso.filter((e) => e.id_tabella == articolo.id_um)
          .length > 0
          ? this.dialog_buffer.id_um
          : null;
      this.dialog_lista.mostra = false;
    },
    selezionaArticoloMassivo(arg) {
      // Mi faccio un oggetto da modificare.
      const obj_tmp = JSON.parse(JSON.stringify(arg));

      // Mi assicuro che il mio oggetto oggetto abbia il campo 'selezionato'.
      if (!obj_tmp.selezionato) {
        arg.selezionato = 0;
      }

      // Aggiorno il campo 'selezionato'
      obj_tmp.selezionato = arg.selezionato == 1 ? 0 : 1;

      // Metto da parte l'indice dell'oggetto che sto modificando.
      let index = -1;
      for (let i = 0; i < this.items_art_mass_art.length; i++) {
        if (
          this.items_art_mass_art[i].NUM_ORDINE == arg.NUM_ORDINE &&
          this.items_art_mass_art[i].COD_ARTICOLO === arg.COD_ARTICOLO
        ) {
          index = i;
        }
      }

      // Forzo l'aggiornamento dei dati e della template.
      this.$set(this.items_art_mass_art, index, obj_tmp);
    },
    selezionaOrdineMassivo(arg) {
      // Mi faccio un oggetto da modificare.
      const obj_tmp = JSON.parse(JSON.stringify(arg));

      // Mi assicuro che lil mio oggetto oggetto abbia il campo 'selezionato'.
      if (!obj_tmp.selezionato) {
        arg.selezionato = 0;
      }

      // Aggiorno il campo 'selezionato'
      obj_tmp.selezionato = arg.selezionato == 1 ? 0 : 1;

      // Metto da parte l'indice dell'oggetto che sto modificando.
      let index = -1;
      for (let i = 0; i < this.items_art_mass.length; i++) {
        if (
          this.items_art_mass[i].id_documento_dettaglio_tmp ==
          arg.id_documento_dettaglio_tmp
        ) {
          index = i;
        }
      }

      // Forzo l'aggiornamento dei dati e della template.
      this.$set(this.items_art_mass, index, obj_tmp);
    },
    salvaModifiche() {
      /* Controllo che per nessuna delle righe che voglio
       * salvare ci sia una quantità superiore alla quantità
       * richiesta per l'ordine a cui quella riga fa riferimento. */

      // Contorllo che il form sia stato compilato
      if (!this.qr_attivo) {
        if (!this.$refs.form.validate() && this.dialog_inserimento.indice < 0) {
          this.$refs.SnackbarQV.print(
            "orange",
            "Valorizzare i campi obbligatori."
          );
          return;
        }
      }

      // Controllo che se richiesto, il lotto_fornitore sia presente.
      if (
        this.dialog_buffer.gestione_lotto == 1 &&
        (this.dialog_buffer.lotto_fornitore == "" ||
          this.dialog_buffer.lotto_fornitore == null)
      ) {
        this.$refs.SnackbarQV.print(
          "orange",
          "Il Lotto Fornitore è necessario per questo articolo."
        );
        return;
      }

      if (this.dialog_buffer.id_documento_dettaglio != null) {
        /* Aggiorno le tabelle degli ordini in items_articoli
         * e in tabellaOrdini.dati in modo che i dati visualizzati
         * siano aggiornati. */

        /* Faccio i controlli sulla quantità prelevabile solo nel
         * caso in cui ci sia un numero d'ordine, ovvero se non
         * mi sono generato una riga di ingresso dal nulla senza
         * riferimento a un ordine specifico. */
        if (
          this.dialog_buffer.num_ordine != null &&
          this.dialog_buffer.num_ordine != ""
        ) {
          // Calcolo la quantità ancora disponibile.
          let quantita_ancora_disponibile = this.items_articoli.filter(
            (a) =>
              a.NUM_ORDINE == this.dialog_buffer.num_ordine &&
              a.COD_ARTICOLO == this.dialog_buffer.cod_articolo
          )[0].QUANTITA;

          /* Calcolo la quantità che vorrei ancora prelevare
           * (questo calcolo tiene conto del fatto che magari
           * sto modificando una riga già esistente e potrei
           * anche stare riducendo la quantità del prelievo.)*/
          const riga_gia_inserita = this.tabella.dati.filter(
            (a) =>
              a.id_documento_dettaglio ==
              this.dialog_buffer.id_documento_dettaglio
          );

          let quantita_da_prelevare =
            riga_gia_inserita.length > 0
              ? riga_gia_inserita[0].quantita - this.dialog_buffer.quantita
              : -this.dialog_buffer.quantita;

          /* Se la quantità di articolo ancora disponibile meno
           * la quantità che vorrei prelevare è < 0, non prelevo;
           * altrimenti prelevo e sottraggo la quantità che voglio
           * prelevare alla quantità ancora prelevabile. Questa
           * operazione, per via dei passaggi precedenti, non si
           * rompe se una riga già esistente sta venendo modificata. */
          if (quantita_ancora_disponibile + quantita_da_prelevare < 0) {
            this.$refs.SnackbarQV.print(
              "orange",
              `Prelievo eccessivo: max ${
                riga_gia_inserita.length > 0
                  ? riga_gia_inserita[0].quantita + quantita_ancora_disponibile
                  : quantita_ancora_disponibile
              }`
            );
            return;
          } else {
            // Scalo la quantità dall'array delle selezioni massive per articolo.
            this.items_articoli.filter(
              (a) =>
                a.NUM_ORDINE == this.dialog_buffer.num_ordine &&
                a.COD_ARTICOLO == this.dialog_buffer.cod_articolo
            )[0].QUANTITA += quantita_da_prelevare;

            /* Scalo la quantità dall'array delle selezioni massive per ordine.
             * La lunga formula magica qui sotto va intesa come segue: se c'è
             * almeno un ordine che corrisponde per numero documento alla mia
             * riga di DDT, e se dentro quell'ordine c'è almeno un articolo che
             * corrisponde alla mia riga di DDT per numero ordine e codice
             * articolo, allora altera la quantità di quell'articolo in base
             * alla quantità della mia riga di DDT. Le istruzioni sono scritte così
             * per ottimizzare il lavoro del processore. */
            if (
              this.items_select_ord_mass.filter(
                (o) => o.num_documento == this.dialog_buffer.num_ordine
              ).length > 0
            ) {
              if (
                this.items_select_ord_mass
                  .filter(
                    (o) => o.num_documento == this.dialog_buffer.num_ordine
                  )[0]
                  .dettaglio.filter(
                    (d) =>
                      d.num_ordine == this.dialog_buffer.num_ordine &&
                      d.cod_articolo == this.dialog_buffer.cod_articolo
                  ).length > 0
              ) {
                this.items_select_ord_mass
                  .filter(
                    (o) => o.num_documento == this.dialog_buffer.num_ordine
                  )[0]
                  .dettaglio.filter(
                    (d) =>
                      d.num_ordine == this.dialog_buffer.num_ordine &&
                      d.cod_articolo == this.dialog_buffer.cod_articolo
                  )[0].quantita += quantita_da_prelevare;
              }
            }
          }
        }

        /* Controllo che la coppia codice lotto fornitore - numero seriale
         * non ricorra per nessuna delle righe già registrate per un oggetto nuovo
         * (per un oggetto non nuovo questa funzione significa che avviene un
         * reinserimento e quindi il controllo non ha senso).*/
        /*let ricorre = false;
        this.tabella.dati.forEach((e) => {
          if (
            e.seriale === this.dialog_buffer.seriale &&
            e.lotto_fornitore === this.dialog_buffer.lotto_fornitore &&
            e.id_documento_dettaglio_tmp !==
              this.dialog_buffer.id_documento_dettaglio_tmp &&
            this.dialog_inserimento.indice < 0
          ) {
            ricorre = true;
          }
        });

        if (ricorre === true) {
          this.$refs.SnackbarQV.print(
            "orange",
            "Questo numero seriale è già stato inserito nel documento con associazione a questo lotto fornitore."
          );
          return;
        }*/
        this.tabella.dati.forEach((e) => {
          if (
            e.id_documento_dettaglio ==
            this.dialog_buffer.id_documento_dettaglio
          ) {
            this.$set(e, "quantita", this.dialog_buffer.quantita);
            this.$set(e, "cod_articolo", this.dialog_buffer.cod_articolo);
            this.$set(e, "cod_lotto", this.dialog_buffer.cod_lotto);
            this.$set(e, "data_scadenza", this.dialog_buffer.data_scadenza);
            this.$set(
              e,
              "prezzo_totale",
              this.dialog_buffer.prezzo_totale
                ? parseFloat(this.dialog_buffer.prezzo_totale).toFixed(3)
                : (0).toFixed(3)
            );
            this.$set(e, "descrizione", this.dialog_buffer.descrizione);
            this.$set(e, "lotto_fornitore", this.dialog_buffer.lotto_fornitore);
            this.$set(e, "peso_netto", this.dialog_buffer.peso_netto);
            this.$set(e, "peso_lordo", this.dialog_buffer.peso_lordo);
            this.$set(
              e,
              "ricezione_peso_netto",
              this.dialog_buffer.ricezione_peso_netto
            );
            this.$set(
              e,
              "ricezione_peso_lordo",
              this.dialog_buffer.ricezione_peso_lordo
            );
            this.$set(e, "note_riga", this.dialog_buffer.note_riga);
            this.$set(e, "num_colli", this.dialog_buffer.num_colli);
            this.$set(e, "id_magazzino", this.dialog_buffer.id_magazzino);
            this.$set(e, "peso_unitario", this.dialog_buffer.peso_unitario);
            this.$set(e, "qta_per_collo", this.dialog_buffer.qta_per_collo);
            this.$set(e, "um", this.dialog_buffer.um);
            this.$set(e, "um_peso", this.dialog_buffer.um_peso);
            this.$set(
              e,
              "allegati",
              this.$refs.DropFileDettaglio.getAttachments()
            );
          }
        });

        this.dialog_inserimento.mostra = false;

        this.key_lotto_tabella = this.key_tabella === 0 ? 1 : 0;
        this.$forceUpdate();
        return;
      }

      /* Se il controllo del codice lotto - numero seriale
       * è passato, metto la riga in tabella. */
      /* Per prima cosa decido se l'oggetto me lo sono
       * compilato da QR code o me lo sono fatto a mano. */
      this.dialog_buffer.qr_encoded =
        this.qr_attivo === false &&
        (this.dialog_buffer.qr_encoded === null ||
          this.dialog_buffer.qr_encoded === undefined)
          ? 0
          : 1;

      // Poi mi costruisco l'oggetto per il salvataggio
      let clone = Object.assign({}, this.dialog_buffer);
      clone.residuo = clone.quantita;
      clone.validita = 1;
      clone.id_documento_dettaglio = -moment().valueOf();
      clone.id_documento_dettaglio_tmp = -moment().valueOf();
      clone.id_documento = -1;
      clone.allegati = this.$refs.DropFileDettaglio.getAttachments();

      /* Mi faccio un array di supporto da usare
       * nel resto della logica di salvataggio. */
      const arr_tmp = this.tabellaOrdini.dati.filter(
        (elem) => elem.COD_ARTICOLO === clone.cod_articolo
      );

      /* Controllo che tutti gli oggetti messi in arr_tmp abbiano una data
       * valida, altrimenti la funzione da risultati erratici. */
      let check_data = true;
      arr_tmp.forEach((elem) => {
        if (
          !elem.DATA_DOCUMENTO.includes("-") ||
          !elem.DATA_CONSEGNA.includes("-")
        ) {
          check_data = false;
        }
      });

      if (check_data === true) {
        this.$refs.SnackbarQV.print(
          "orange",
          "I dati degli ordini non sono corretti, impossibile leggere i dati."
        );
      }

      // Controllo che le quantità in ordine non eccedano oltre i 500
      // let somma = 0;
      // arr_tmp.forEach((elem) => {
      //   if (elem.COD_ARTICOLO === clone.cod_articolo) {
      //     somma += elem.QUANTITA;
      //   }
      // });

      // if (clone.residuo - somma <= 500) {

      /* Se il controllo della quantità è pasato, procedo
       * a praprare gli oggetti per il salvataggio. */
      let qta_div_colli = clone.residuo;
      if (clone.num_colli > 1) {
        qta_div_colli = parseInt(clone.residuo / clone.num_colli);
      }

      let qta_rimasta = clone.residuo;

      for (let i = 0; i < clone.num_colli; i++) {
        // Questo se è quantità totale (da dividere per numero di colli)...
        if (this.dialog_buffer.qta_per_collo === true) {
          qta_rimasta = this.dialog_buffer.quantita;
        } else {
          if (i < clone.num_colli - 1) {
            qta_rimasta = qta_div_colli;
          } else {
            qta_rimasta = this.dialog_buffer.quantita - qta_div_colli * i;
          }
        }

        // ... Altrimenti...

        let int_riga = 0;

        clone.quantita = qta_rimasta;
        while (qta_rimasta > 0 && int_riga < arr_tmp.length) {
          if (qta_rimasta <= arr_tmp[int_riga].QUANTITA) {
            arr_tmp[int_riga].QUANTITA -= qta_rimasta;
            qta_rimasta = 0;
          } else {
            qta_rimasta -= arr_tmp[int_riga].QUANTITA;
            arr_tmp[int_riga].QUANTITA = 0;
          }

          if (
            arr_tmp[int_riga].DATA_CONSEGNA &&
            moment(`${arr_tmp[int_riga].DATA_CONSEGNA.split(" ")[0]}`) >
              moment()
          ) {
            this.$refs.SnackbarQV.print(
              "success",
              `Quantità in acconto sulla prossima consegna del ${
                arr_tmp[int_riga].DATA_CONSEGNA.split("-")[2]
              }/${arr_tmp[int_riga].DATA_CONSEGNA.split("-")[1]}/${
                arr_tmp[int_riga].DATA_CONSEGNA.split("-")[0]
              }.`
            );
          }

          int_riga++;
        }
        if (qta_rimasta > 0 && arr_tmp.length > 0) {
          arr_tmp[arr_tmp.length - 1].QUANTITA -= qta_rimasta;
        }

        clone.residuo = qta_rimasta;

        let clone2 = Object.assign({}, clone);
        clone2.num_colli = 1;

        /* Aggiorno le tabelle degli ordini in items_articoli
         * e in tabellaOrdini.dati in modo che i dati visualizzati
         * siano aggiornati. */

        // Calcolo la quantità ancora disponibile.
        let quantita_ancora_disponibile = 0;
        if (this.is_ingresso_from_ordine === true) {
          quantita_ancora_disponibile =
            this.items_articoli.filter(
              (a) =>
                a.NUM_ORDINE == clone2.num_ordine &&
                a.COD_ARTICOLO == clone2.cod_articolo
            ).length > 0
              ? this.items_articoli.filter(
                  (a) =>
                    a.NUM_ORDINE == clone2.num_ordine &&
                    a.COD_ARTICOLO == clone2.cod_articolo
                )[0].QUANTITA
              : 0;
        }

        /* Calcolo la quantità che vorrei ancora prelevare
         * (questo calcolo tiene conto del fatto che magari
         * sto modificando una riga già esistente e potrei
         * anche stare riducendo la quantità del prelievo.)*/
        const riga_gia_inserita = this.tabella.dati.filter(
          (a) => a.id_documento_dettaglio == clone2.id_documento_dettaglio
        );

        let quantita_da_prelevare =
          riga_gia_inserita.length > 0
            ? riga_gia_inserita[0].quantita - clone2.quantita
            : -clone2.quantita;

        /* Se la quantità di articolo ancora disponibile meno
         * la quantità che vorrei prelevare è < 0, non prelevo;
         * altrimenti prelevo e sottraggo la quantità che voglio
         * prelevare alla quantità ancora prelevabile. Questa
         * operazione, per via dei passaggi precedenti, non si
         * rompe se una riga già esistente sta venendo modificata. */
        if (
          quantita_ancora_disponibile + quantita_da_prelevare < 0 &&
          this.is_ingresso_from_ordine === true
        ) {
          this.$refs.SnackbarQV.print(
            "orange",
            `Prelievo eccessivo: max ${
              riga_gia_inserita.length > 0
                ? riga_gia_inserita[0].quantita + quantita_ancora_disponibile
                : quantita_ancora_disponibile
            }`
          );
          return;
        } else if (this.is_ingresso_from_ordine === true) {
          this.items_articoli.filter(
            (a) =>
              a.NUM_ORDINE == clone2.num_ordine &&
              a.COD_ARTICOLO == clone2.cod_articolo
          )[0].QUANTITA += quantita_da_prelevare;
        }

        // Se non c'è un prezzo ne inserisco uno fittizio.
        clone2.prezzo_totale =
          parseFloat(clone2.prezzo_totale).toFixed(3) ?? (0).toFixed(3);

        // Se è un oggetto nuovo, lo inserisco in coda alla tabella
        if (this.dialog_inserimento.indice < 0) {
          /* Devo modificare id_documento_dettaglio per le righe di DDT nuove:
           * se sto salvando più colli questi non devono avere lo stesso
           * id_commessa_dettaglio, quindi faccio in modo di generare dei
           * nuovi timestamp per tutti i colli successivi al primo; per il
           * primo non cambio in alcun modo l'id_commessa_dettaglio perché
           * potrei avere degli allegati, che sono legati alla chiave primaria
           * rappresentata dal timestamp originale. */
          clone2.id_documento_dettaglio =
            i == 0 ? clone2.id_documento_dettaglio : -moment().valueOf() - i;

          this.tabella.dati.push(Object.assign({}, clone2));
        } else {
          // Se non è un oggetto nuovo, modifico la riga di tabella corrispondente
          this.tabella.dati[this.dialog_inserimento.indice] = Object.assign(
            {},
            clone2
          );
        }

        if (this.qr_attivo) {
          this.$refs.SnackbarQV.print("success", "QR valido.");
          this.$refs.qr.attiva_telecamera();
        } else {
          this.$refs.SnackbarQV.print("success", "Ingresso registrato.");
        }
      }

      this.dialog_inserimento.mostra = false;
    },
    salvaDati() {
      // Controllo che tutte le righe abbiano un lotto fornitore.
      let chk_lotto_fornitore = true;
      this.tabella.dati.forEach((d) => {
        if (
          (d.lotto_fornitore == "" || d.lotto_fornitore == null) &&
          d.gestione_lotto == 1
        ) {
          chk_lotto_fornitore = false;
        }
      });

      if (chk_lotto_fornitore === false) {
        this.$refs.SnackbarQV.print(
          "orange",
          "Compilare i lotti fornitore richiesti prima di salvare."
        );
        return;
      }

      if (
        !(
          this.dettaglio.cod_anagrafica &&
          this.dettaglio.ragione_sociale &&
          this.dettaglio.num_documento &&
          this.dettaglio.data_documento
        )
      ) {
        this.$refs.SnackbarQV.print(
          "error",
          "Tutti i campi del form devono essere valorizzati."
        );
        return;
      } else if (!this.tabella.dati.length) {
        this.$refs.SnackbarQV.print(
          "error",
          "Il documento deve contenere almeno un articolo"
        );
        return;
      }

      this.dettaglio.dettaglio = this.tabella.dati;
      this.setDocumento();
    },
    clickStampaAccettazioni(arg_modalita) {
      /* Se il documento non è ancora stato salvato
       * non posso ancora stampare le etichette
       * perché non ho dati a DB, quindi mi fermo. */
      if (this.dettaglio.id_documento < 0) {
        this.$refs.SnackbarQV.print(
          "orange",
          "Per eseguire la stampa il DDT deve essere salvato."
        );
        return;
      }

      // Controllo che ci siano righe da stampare.
      if (this.tabella.dati.length == 0) {
        this.$refs.SnackbarQV.print(
          "orange",
          "Il DDT non contiene righe da stampare."
        );
        return;
      }

      /* Registro di essere in modalità
       * di stampa delle righe filtrate
       * o di stampa di tutte le righe. */
      this.modalita_stampa = arg_modalita;

      this.conferma_stampa_visible = true;
    },
    stampaAccettazioni() {
      const tabella_tmp = new Array();

      // Resetto l'array delle etichette.
      this.etichette = new Array();

      this.tabella.dati.forEach((d) => {
        /* Mi prendo l'id_documento_dettaglio se
         * la pedana è selezionata per la stampa. */
        if (d.stampa === true && this.modalita_stampa === "filtro") {
          tabella_tmp.push({
            cod_articolo: d.cod_articolo,
            id_documento_dettaglio: d.id_documento_dettaglio,
          });
        }
      });

      /* Se sono in modalità di stampa con filtro, stampo
       * solo le etichette che mi sono messo da parte. Se
       * sono in modalità di stampa totale, stampo tutto
       * il documento. */
      if (this.modalita_stampa == "filtro") {
        this.stampaEtichetteFiltrate(tabella_tmp);
      } else if (this.modalita_stampa == "totale") {
        this.stampaTotaleEtichette();
      }
    },
    stampaEtichetteFiltrate(arg_arr) {
      let request_buffer = 0;
      arg_arr.forEach((d) => {
        const request = {
          controller: "Magazzino",
          method: "POST",
          richiesta: {
            action: "printqrcode",
            token: localStorage.user_token,
            id_documento_dettaglio: d.id_documento_dettaglio,
          },
        };

        // Incremento il request_buffer.
        request_buffer++;

        // Attivo l'overlay di caricamento.
        this.overlay_etichette = true;

        this.$store
          .dispatch("api", request)
          .then((res) => {
            // Decremento il request_buffer
            request_buffer--;

            if (res.status === 200) {
              this.$set(this.etichette, this.etichette.length, {
                titolo: d.cod_articolo,
                base64: res.data.result,
              });
            } else {
              this.$refs.SnackbarQV.print(
                "orange",
                "Errore di comunicazione col server, non  stato possibile salvare i dati."
              );
            }

            if (request_buffer <= 0) {
              this.overlay_etichette = false;
            }
          })
          .catch((err) => {
            // Decremento il request_buffer
            request_buffer--;

            console.error(err);
            this.$refs.SnackbarQV.print(
              "error",
              "Errore di comunicazione col server, non  stato possibile salvare i dati."
            );

            if (request_buffer <= 0) {
              this.overlay_etichette = false;
            }
          });
      });
    },
    stampaTotaleEtichette() {
      const request = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "printqrcode",
          token: localStorage.user_token,
          id_documento: this.dettaglio.id_documento,
        },
      };

      // Attivo l'overlay di caricamento.
      this.overlay_etichette = true;

      this.$store
        .dispatch("api", request)
        .then((res) => {
          if (res.status === 200) {
            this.$set(this.etichette, this.etichette.length, {
              titolo: this.dettaglio.num_documento,
              base64: res.data.result,
            });
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non  stato possibile salvare i dati."
            );
          }

          this.overlay_etichette = false;
        })
        .catch((err) => {
          console.error(err);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, non  stato possibile salvare i dati."
          );

          this.overlay_etichette = false;
        });
    },

    // Questa chiamata permetteva di avere i dati di un articolo selezionato manualmente
    // dalla lista degli articoli, per scelte implementative si è deciso di prendere
    // i dettagli dell'articolo dalla selezione nella lista degli ordini.
    getArticoli() {
      this.dialog_lista.caricamento = true;

      let richiesta = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getArticoli",
          token: localStorage.user_token,
          cod_articolo: this.dialog_buffer.cod_articolo,
          des_articolo: this.dialog_buffer.descrizione,
        },
      };
      let that = this;
      this.$store.dispatch("api", richiesta).then((risposta) => {
        if (risposta.data.lista.length > 1) {
          that.dialog_lista.tabella.dati = risposta.data.lista;
          // that.dialog_lista.caricamento = false;
          this.dialog_lista.mostra = true;
        }

        if (risposta.data.lista.length === 0) {
          this.snackbar = true;
          this.snackbar_background = "error";
          this.snackbar_icon = "mdi-close";
          this.snackbar_icon_color = "white";
          this.snackbar_text =
            "Non sono stati trovati articoli con questo nome.";
          this.snackbar_text_color = "white";
        }

        if (risposta.data.lista.length === 1) {
          that.dialog_lista.tabella.dati = risposta.data.lista;
          that.dialog_lista.caricamento = false;
          this.dialog_lista.mostra = true;
        }
      });
    },

    getAnagrafica() {
      let searchReq = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getragionesociale",
          token: localStorage.getItem("user_token"),
          cod_anagrafica: this.dettaglio.cod_anagrafica,
          des_anagrafica: this.dettaglio.ragione_sociale,
          tipo_anagrafica: "F",
        },
      };
      this.$store.dispatch("api", searchReq).then((res) => {
        if (res.data.length === 0) {
          this.snackbar = true;
          this.snackbar_background = "error";
          this.snackbar_icon = "mdi-close";
          this.snackbar_icon_color = "white";
          this.snackbar_text = "Il Fornitore non è stato trovato. Riprova!";
          this.snackbar_text_color = "white";
          this.loadingVal = false;
          this.progressBar = false;
          this.savebutton = false;
          this.topDiv = true;
        }
        if (res.data.length > 1) {
          this.ragioneSocialeLista = res.data;
          this.dialogSearchAnagrafica = true;
        }
        if (res.data.length == 1) {
          this.dialogSearchAnagrafica = true;
          this.overlay = false;
          this.ragioneSocialeLista = res.data;
          this.dialogSearchAnagrafica = true;
        }
      });
    },

    getDocumento() {
      let richiesta = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getdocumento",
          token: localStorage.user_token,
          id_documento: this.computed_bolla_dettaglio,
        },
      };
      this.$store.dispatch("api", richiesta).then((risposta) => {
        this.dettaglio = Object.assign({}, risposta.data.documento[0]);

        if (!this.admin_power) {
          let res = risposta.data.documento[0].dettaglio;
          const arr = res.filter((elem) => elem.validita);
          this.tabella.dati = arr;
        } else {
          this.tabella.dati = risposta.data.documento[0].dettaglio;
        }
        this.codice_fornitore_sel = this.dettaglio.cod_anagrafica;
      });
    },
    getOrdini() {
      let richiesta = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getordini",
          token: localStorage.user_token,
          cod_anagrafica: this.dettaglio.cod_anagrafica,
          id_anagrafica: this.dettaglio.id_anagrafica,
          cod_documento: "ORDF",
          id_documento: "%",
        },
      };

      // Faccio scattare l'overlay di caricamento
      this.caricamento = true;

      this.$store
        .dispatch("api", richiesta)
        .then((risposta) => {
          if (risposta.status === 200) {
            // Fermo l'overlay di caricamento
            this.caricamento = false;
            let arr_tmp = risposta.data.documento;
            let result = [];

            // Resetto l'array delle selezioni massive da ordine.
            this.items_select_ord_mass = new Array();

            arr_tmp.forEach((e) => {
              /* Genero un oggetto per la lista di selezione
               * che mi premette di scegliere l'ordine da
               * cui fare aggiunta massiva di articoli. */
              const ord_tmp = new Object();
              ord_tmp.dettaglio = new Array();
              ord_tmp.id_documento = e.id_documento;
              ord_tmp.num_documento = e.num_documento;

              /* Compongo un oggetto per l'aggiunta di riga singola
               * e un altro oggetto da inserire nell'array della
               * selezione massiva di articoli da ordine. */
              e.dettaglio.forEach((d) => {
                let obj_ord = {};
                obj_ord.DATA_DOCUMENTO = e.data_documento;
                obj_ord.DATA_CONSEGNA = d.data_consegna_
                  ? d.data_consegna_
                  : "";
                obj_ord.NUM_ORDINE = e.num_documento;
                obj_ord.RIGA_ORDINE = d.riga_ordine;
                obj_ord.QUANTITA = d.quantita - d.qnt_ricevuta;
                obj_ord.quantita_max_prelevabile = d.quantita - d.qnt_ricevuta;
                obj_ord.COD_ARTICOLO = d.cod_articolo;
                obj_ord.descrizione = d.descrizione;
                obj_ord.um = d.um;
                obj_ord.id_um = d.id_um;
                obj_ord.id_documento_rif = e.id_documento;
                obj_ord.id_documento_dettaglio_rif = d.id_documento_dettaglio;
                obj_ord.articolo_massivo = 0;
                obj_ord.gestione_lotto = d.gestione_lotto;
                obj_ord.id_magazzino = d.id_magazzino;
                obj_ord.id_articolo = d.id_articolo;
                obj_ord.num_documento = e.num_documento;
                obj_ord.id_documento = this.dettaglio.id_documento;
                obj_ord.ricezione_peso_netto = d.ricezione_peso_netto;
                obj_ord.ricezione_peso_lordo = d.ricezione_peso_lordo;

                // Aggiungo l'articolo per la selezione singola.
                result.push(obj_ord);

                // Aggiungo l'articolo nell'array per la selezione massiva.
                const obj_mass = new Object();
                obj_mass.cod_articolo = d.cod_articolo;
                obj_mass.DATA_DOCUMENTO = e.data_documento;
                obj_mass.DATA_CONSEGNA = d.data_consegna_
                  ? d.data_consegna_
                  : "";
                obj_mass.descrizione = d.descrizione;
                obj_mass.num_colli = d.num_colli;
                obj_mass.quantita = d.quantita - d.qnt_ricevuta;
                obj_mass.quantita_max_prelevabile = d.quantita - d.qnt_ricevuta;
                obj_mass.num_ordine = e.num_documento;
                obj_mass.um = d.um;
                obj_mass.id_um = d.id_um;
                obj_mass.riga_ordine = d.riga_ordine;
                obj_mass.id_documento_rif = e.id_documento;
                obj_mass.id_documento_dettaglio_rif = d.id_documento_dettaglio;
                obj_mass.validita = 1;
                obj_mass.selezionato = 0;
                obj_mass.articolo_massivo = 1;
                obj_mass.gestione_lotto = d.gestione_lotto;
                obj_mass.id_documento_dettaglio =
                  -moment().valueOf() - ord_tmp.dettaglio.length;
                obj_mass.id_documento_dettaglio_tmp =
                  obj_mass.id_documento_dettaglio;

                obj_mass.id_magazzino = d.id_magazzino;
                obj_mass.id_articolo = d.id_articolo;
                obj_mass.num_documento = e.num_documento;
                obj_mass.id_documento = this.dettaglio.id_documento;
                obj_mass.ricezione_peso_netto = d.ricezione_peso_netto;
                obj_mass.ricezione_peso_lordo = d.ricezione_peso_lordo;

                ord_tmp.dettaglio.push(obj_mass);
              });

              /* Aggiungo l'ordine intero, con tutti i suoi
               * articoli, all'array per la selezione massiva. */
              this.items_select_ord_mass.push(ord_tmp);
            });

            // Guardo gli ordini per come li ho adesso
            const ordini_dati_bu =
              this.tabellaOrdini.dati.length === 0
                ? []
                : Array.from(this.tabellaOrdini.dati);
            const ordini_ori_bu =
              this.ordini_originali.length === 0
                ? []
                : Array.from(this.ordini_originali);

            // Resetto le tabelle di supporto
            this.tabellaOrdini.dati = [];
            this.items_articoli = [];
            this.ordini_originali = [];

            if (result.riga1) {
              for (let campo in result) {
                this.tabellaOrdini.dati.push(Object.assign({}, result[campo]));
                this.items_articoli.push(Object.assign({}, result[campo]));
              }
            } else {
              // this.tabellaOrdini.dati = [result];
              // this.items_articoli = [result];
              this.tabellaOrdini.dati = result;
              this.items_articoli = result;
            }

            /* Controllo che nessun ordine che già avevo abbia una quantità cambiata.
             * Se è cambiata, stampo una snackbar di errore e resetto le righe del DDT. */
            let chk_qta_uguali = true;
            ordini_ori_bu.forEach((o_ori) => {
              this.tabellaOrdini.dati.forEach((o_new) => {
                if (
                  o_ori.NUM_ORDINE === o_new.NUM_ORDINE &&
                  o_ori.RIGA_ORDINE === o_new.RIGA_ORDINE &&
                  o_ori.DATA_DOCUMENTO === o_new.DATA_DOCUMENTO &&
                  o_ori.DATA_CONSEGNA === o_new.DATA_CONSEGNA &&
                  o_ori.COD_ARTICOLO === o_new.COD_ARTICOLO &&
                  o_ori.QUANTITA != o_new.QUANTITA
                ) {
                  chk_qta_uguali = false;
                }
              });
            });

            if (chk_qta_uguali === false) {
              this.tabella.dati = [];
              this.$refs.SnackbarQV.print(
                "orange",
                "La quantità degli ordini referenziati dalle righe del DDT è cambiata, è necessario ricompilare!",
                10000
              );
              return;
            }

            /* Se le quantità degli ordini non è mutata, aggiorno le
             * loro quantità */
            ordini_dati_bu.forEach((o_dato) => {
              this.tabellaOrdini.dati.forEach((o_new) => {
                if (
                  o_dato.NUM_ORDINE === o_new.NUM_ORDINE &&
                  o_dato.RIGA_ORDINE === o_new.RIGA_ORDINE &&
                  o_dato.DATA_DOCUMENTO === o_new.DATA_DOCUMENTO &&
                  o_dato.DATA_CONSEGNA === o_new.DATA_CONSEGNA &&
                  o_dato.COD_ARTICOLO === o_new.COD_ARTICOLO &&
                  o_dato.QUANTITA != o_new.QUANTITA
                ) {
                  o_new.QUANTITA = o_dato.QUANTITA;
                }
              });
            });

            // Ora posso controllare le qtà rispetto alla tabella degli arrivi
            // this.tabella.dati.forEach((ordine_tbl) => {
            //   let qta_ordine_utile = ordine_tbl.quantita;
            //   this.tabellaOrdini.dati.forEach((ordine) => {
            //     if (
            //       ordine_tbl.riga_ordine == ordine.RIGA_ORDINE &&
            //       ordine_tbl.validita != 0 &&
            //       qta_ordine_utile > 0 &&
            //       ordine.QUANTITA + 500 > ordine_tbl.quantita
            //     ) {
            //       ordine.QUANTITA = ordine.QUANTITA - ordine_tbl.quantita;
            //       qta_ordine_utile = qta_ordine_utile - qta_ordine_utile;
            //     }
            //   });
            // });

            this.items_articoli = _.cloneDeep(this.tabellaOrdini.dati);
            this.ordini_originali = _.cloneDeep(this.tabellaOrdini.dati);

            if (this.dettaglio.synch === null) {
              for (let i = 0; i < this.tabellaOrdini.dati.length; i++) {
                for (let j = 0; j < this.dettaglio.dettaglio.length; j++) {
                  if (
                    this.tabellaOrdini.dati[i].COD_ARTICOLO ==
                      this.dettaglio.dettaglio[j].cod_articolo &&
                    this.tabellaOrdini.dati[i].RIGA_ORDINE ==
                      this.dettaglio.dettaglio[j].num_riga &&
                    this.dettaglio.dettaglio[j].validita != 0 &&
                    this.dettaglio.dettaglio[j].id_documento_dettaglio < 0
                  ) {
                    this.tabellaOrdini.dati[i].QUANTITA =
                      this.tabellaOrdini.dati[i].QUANTITA -
                      this.dettaglio.dettaglio[j].quantita;
                  }
                }
              }
            }
          } else {
            this.caricamento = false;
            this.snackbar = true;
            this.snackbar_text =
              "Nessun ordine disponibile per questo fornitore";
            this.snackbar_background = "error";
          }
        })
        .catch((error) => {
          this.caricamento = false;
          console.error(error);
          this.snackbar = true;
          this.snackbar_text = "Nessun ordine trovato per questo fornitore";
          this.snackbar_background = "error";
        });
    },
    async getQr(arg) {
      if (arg.includes("GETQRCPS;") && arg.includes("(P)")) {
        // Pesco il codice articolo
        let codice_articolo;
        codice_articolo = arg.split("(P)")[1].split(";")[0];

        // Pesco il numero seriale
        let seriale_tmp;
        if (arg.includes("(B)"))
          seriale_tmp = arg.split("(B)")[1].split(";")[0];

        // Pesco la quantità ordine
        let qta;
        if (arg.includes("(Q)")) qta = arg.split("(Q)")[1].split(";")[0];

        // Pesco il lotto fornitore
        let lotto_fornitore;
        if (arg.includes("(H)"))
          lotto_fornitore = arg.split("(H)")[1].split(";")[0];

        /* Controllo che la coppia codice lotto fornitore - numero seriale
         * non ricorra per nessuna delle righe già registrate.*/
        let ricorre = false;
        this.tabella.dati.forEach((e) => {
          if (
            e.seriale === seriale_tmp &&
            e.lotto_fornitore === lotto_fornitore
          ) {
            ricorre = true;
          }
        });

        // Faccio controllare al BE che il QR non sia già stato letto in passato
        const chk_qr = await this.checkQrCode(arg);

        if (chk_qr != false) {
          this.$refs.SnackbarQV.print(
            "orange",
            `Questo codice è associato al documento ${chk_qr} e non può più essere riutilizzato.`,
            10000
          );
          return;
        }

        if (ricorre === true) {
          this.$refs.SnackbarQV.print(
            "orange",
            "Questo numero seriale è già stato inserito nel documento con associazione a questo lotto fornitore."
          );
          this.qr_attivo = false;
          // this.$refs.qr.attiva_telecamera();
          return;
        }

        // Prendo l oggetto dall array ordini se il codice articolo nel qrcode è
        // uguale al codice dell array
        let ordine_tmp;
        let cod_art_ricorre = false;

        this.tabellaOrdini.dati.forEach((e) => {
          if (e.COD_ARTICOLO == codice_articolo) {
            ordine_tmp = e;
            cod_art_ricorre = true;
          }
        });

        if (cod_art_ricorre === false) {
          this.$refs.SnackbarQV.print("error", "Articolo non in ordine");
          this.qr_attivo = false;
          return;
        }

        this.selezionaOrdine(ordine_tmp, seriale_tmp, qta, lotto_fornitore);
      } else {
        this.$refs.SnackbarQV.print("error", "QR code non valido.");
        this.qr_attivo = false;
      }
    },

    goToAnagrafica() {
      if (
        (this.dettaglio.ragione_sociale === "" ||
          this.dettaglio.ragione_sociale === null) &&
        (this.dettaglio.cod_anagrafica === "" ||
          this.dettaglio.cod_anagrafica === null)
      ) {
        return;
      }

      // this.overlay = true;
      let request = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getragionesociale",

          token: localStorage.getItem("user_token"),
          cod_anagrafica: this.dettaglio.cod_anagrafica,
          des_anagrafica: this.dettaglio.ragione_sociale,
          id_famiglia:
            this.id_famiglia_sel == null ? "" : this.id_famiglia.id_tabella,
          id_tipo: this.id_tipo == null ? "" : this.id_tipo.id_tabella,
        },
      };
      this.$store.dispatch("api", request).then((res) => {
        this.overlay = false;

        if (res.data.length > 1) {
          this.snackbar = true;
          this.snackbar_background = "orange";
          this.snackbar_icon = "mdi-alert";
          this.snackbar_icon_color = "white";
          this.snackbar_text = "Sono presenti più fornitori con questo nome.";
          this.snackbar_text_color = "white";
          this.ragioneSocialeLista = res.data;
          this.dialogSearchAnagrafica = true;
        }

        if (res.data.length === 0) {
          this.snackbar = true;
          this.snackbar_background = "error";
          this.snackbar_icon = "mdi-close";
          this.snackbar_icon_color = "white";
          this.snackbar_text =
            "Non sono stati trovati fornitori con questo nome.";
          this.snackbar_text_color = "white";
        }

        if (res.data.length === 1) {
          this.selezionaAnagrafica(res.data[0]);
        }
      });

      // this.articolo_search_results = false;
    },

    // Commentata questa sezione perché l'inserimento dell'articolo
    // deve essere inserito dal dialog di selezione dell'ordine.
    goToArticolo() {
      if (this.dialog_buffer.cod_articolo === "") {
        return;
      }

      // this.overlay = true;
      let request = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getarticoli",
          token: localStorage.getItem("user_token"),
          des_articolo: this.dialog_buffer.descrizione,
          cod_articolo: this.dialog_buffer.cod_articolo,
          id_famiglia:
            this.id_famiglia_sel == null ? "" : this.id_famiglia.id_tabella,
          id_tipo: this.id_tipo == null ? "" : this.id_tipo.id_tabella,
        },
      };
      this.$store.dispatch("api", request).then((res) => {
        this.overlay = false;

        if (res.data.lista.length === 0) {
          this.snackbar = true;
          this.snackbar_background = "error";
          this.snackbar_icon = "mdi-close";
          this.snackbar_icon_color = "white";
          this.snackbar_text =
            "Non sono stati trovati articoli con questo codice.";
          this.snackbar_text_color = "white";
        }

        if (res.data.lista.length === 1) {
          this.selezionaArticolo(res.data.lista[0]);
        }
      });

      // this.articolo_search_results = false;
    },
    handleSalvatiDisegni(arg) {
      const obj_tmp = {
        id_segnalazione: -1,
        pk_riferimento: arg.pk_riferimento,
        id_riferimento: arg.id_riferimento,
        riferimento: arg.riferimento,
        tipo: arg.tipologia,
        note: arg.descrizione,
        cod_documento: this.input_args.cod_documento,
        num_documento: this.input_args.num_documento,
        cod_articolo: this.input_args.cod_articolo,
        data_documento: this.input_args.data_documento,
      };

      const request = {
        controller: "Magazzino",
        method: "PUT",
        richiesta: {
          action: "setsegnalazioni",
          segnalazioni: [obj_tmp],
          token: localStorage.user_token,
        },
      };

      this.$store
        .dispatch("api", request)
        .then((res) => {
          if (res.status === 200) {
            const request2 = {
              controller: "Magazzino",
              method: "PUT",
              richiesta: {
                action: "setsegnalazioniimmagini",
                token: localStorage.user_token,
                immagini: arg.imgs,
                id_segnalazione: res.data.segnalazioni[0].id_segnalazione,
              },
            };

            this.$store
              .dispatch("api", request2)
              .then((res2) => {
                if (res2.status === 200) {
                  this.dialog_segnalazioni = false;
                  this.$refs.SnackbarQV.print(
                    "success",
                    "Segnalazione registrata con successo!"
                  );
                }
              })
              .catch((err) => {
                console.error(err);
                this.$refs.SnackbarQV.print(
                  "error",
                  "Errore di comunicazione col server, non è stato possibile salvare le segnalazioni."
                );
              });
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non è stato possibile salvare le segnalazioni."
            );
          }
        })
        .catch((err) => {
          console.error(err);
          this.$refs.SnackbarQV(
            "error",
            "Errore di comunicazione col server, non è stato possibile salvare le segnalazioni."
          );
        });
    },
    clickSelectMassDaArticolo() {
      /* Resetto l'ordine selezionato. Se non metto null come stringa ma
       * come valore, la autocomplete rimane ferma all'ultimo valore che
       * faceva match; per resettarla davvero devo usare una stringa. */
      this.id_articolo_mass_sel = "null";

      // Resetto gli articoli selezionati.
      this.items_art_mass = new Array();

      this.dialog_selezione_massiva_articolo = true;
    },
    clickSelectMassDaOrdine() {
      // Resetto l'ordine selezionato.
      this.id_ordine_mass_sel = null;

      // Resetto gli articoli selezionati.
      this.items_art_mass = new Array();

      this.dialog_selezione_massiva_fornitore = true;
    },
    salvataggioMassivo() {
      /* Controllo che non siano stati selezionati
       * articoli già completamente ricevuti. */
      let chk_quantita = true;
      let cod_no_quantita = "";

      this.items_art_mass.forEach((a) => {
        if (a.selezionato == 1 && a.quantita == 0) {
          chk_quantita = false;
          cod_no_quantita = a.cod_articolo;
        }
      });

      if (chk_quantita === false) {
        this.$refs.SnackbarQV.print(
          "orange",
          `Impossibile eseguire il salvataggio: l'articolo ${cod_no_quantita} ha quantità nulla.`
        );
        return;
      }

      // Controllo che gli articoli selezionati abbiano un id_magazzino.
      let chk_magazzino = true;
      let cod_no_magazzino = "";

      this.items_art_mass.forEach((a) => {
        if (
          (a.selezionato == 1 && a.id_magazzino == null) ||
          a.id_magazzino == ""
        ) {
          chk_magazzino = false;
          cod_no_magazzino = a.cod_articolo;
        }
      });

      if (chk_magazzino === false) {
        this.$refs.SnackbarQV.print(
          "orange",
          `Impossibile eseguire il salvataggio: l'articolo ${cod_no_magazzino} non ha un magazzino predefinito.`
        );
        return;
      }

      this.items_art_mass.forEach((a) => {
        if (a.selezionato == 1) {
          /* Aggiorno le tabelle degli ordini in items_articoli
           * e in tabellaOrdini.dati in modo che i dati visualizzati
           * siano aggiornati. */
          this.items_select_ord_mass.forEach((o) => {
            if (o.id_documento === this.id_ordine_mass_sel) {
              o.dettaglio.filter(
                (d) =>
                  d.cod_articolo == a.cod_articolo &&
                  d.num_ordine == a.num_ordine &&
                  d.data_consegna == a.data_consegna
              )[0].quantita = 0;
            }
          });

          this.items_articoli.forEach((e) => {
            if (
              e.COD_ARTICOLO == a.cod_articolo &&
              e.NUM_ORDINE == a.num_ordine &&
              e.DATA_CONSEGNA == a.DATA_CONSEGNA
            ) {
              e.QUANTITA = 0;
            }
          });

          // Aggiungo l'oggetto alla tabella delle ricezioni.
          a.data_documento = a.DATA_DOCUMENTO;
          a.data_consegna = a.DATA_CONSEGNA;
          delete a.DATA_DOCUMENTO;
          delete a.DATA_CONSEGNA;

          a.peso_netto = a.ricezione_peso_netto == 1 ? a.quantita : null;
          a.peso_lordo = a.ricezione_peso_lordo == 1 ? a.quantita : null;
          a.um_peso =
            a.ricezione_peso_netto == 1 || a.ricezione_peso_lordo == 1
              ? a.id_um
              : null;

          // Inserisco un prezzo di default.
          a.prezzo_totale = (0).toFixed(3);

          this.tabella.dati.push(JSON.parse(JSON.stringify(a)));
        }
      });

      // Chiudo i dialog che erano stati precedentemente aperti.
      this.dialog_selezione_massiva_fornitore = false;
    },
    saveAllegatiDocumento() {
      this.allegati_documento = this.$refs.DropFileDocumento.getAttachments();
      this.dialog_allegato_documento = false;
    },
    saveAllegatiRiga() {
      // Trovo l'indice dell'oggetto modificato.
      const indice = this.tabella.dati.findIndex(
        (e) =>
          e.id_documento_dettaglio == this.dialog_buffer.id_documento_dettaglio
      );

      // Uso l'indice per aggiornare la tabella.
      if (indice != -1) {
        this.tabella.dati[indice].allegati =
          this.$refs.DropFileRiga.getAttachments();
      }

      this.dialog_allegato_riga = false;
    },
    showPdfViewer(arg) {
      // this.iframeUrl = "data:application/pdf;base64," + arg;
      const b64toBlob = (b64Data, sliceSize = 512) => {
        const byteCharacters = atob(b64Data);
        const byteArrays = [];
        for (
          let offset = 0;
          offset < byteCharacters.length;
          offset += sliceSize
        ) {
          const slice = byteCharacters.slice(offset, offset + sliceSize);

          const byteNumbers = new Array(slice.length);
          for (let i = 0; i < slice.length; i++) {
            byteNumbers[i] = slice.charCodeAt(i);
          }

          const byteArray = new Uint8Array(byteNumbers);
          byteArrays.push(byteArray);
        }

        const blob = new Blob(byteArrays, { type: "application/pdf" });
        return blob;
      };
      const blob = b64toBlob(arg);
      const blob_url = URL.createObjectURL(blob);
      window.open(blob_url, "_blank");
      //this.dialog_preview = true;
    },
    selectArtMass() {
      if (this.id_ordine_mass_sel != null) {
        this.items_select_ord_mass.forEach((o) => {
          if (o.id_documento === this.id_ordine_mass_sel) {
            this.items_art_mass = JSON.parse(JSON.stringify(o.dettaglio));
          }
        });
      }
    },
    selectArtMassArt() {
      // Resetto l'array degli articoli selezionabili.
      this.items_art_mass_art = new Array();

      // Popolo l'array degli articoli selezionabili.
      if (this.id_articolo_mass_sel != null) {
        this.items_articoli.forEach((a) => {
          if (a.id_articolo === this.id_articolo_mass_sel && a.QUANTITA > 0) {
            this.items_art_mass_art.push(JSON.parse(JSON.stringify(a)));
          }
        });
      }
    },
    selezionaTuttiArticoliMassivi() {
      this.items_art_mass.forEach((a) => {
        if (a.quantita > 0) {
          this.selezionaOrdineMassivo(a);
        }
      });
    },
    selezionaTuttiArticoliMassiviArt() {
      this.items_art_mass_art.forEach((a) => {
        if (a.QUANTITA > 0) {
          this.selezionaArticoloMassivo(a);
        }
      });
    },
    setDocumento() {
      // Controllo che ci sia almeno una riga d'ordine all'interno del DDT
      if (this.tabella.dati.filter((e) => e.validita === 1).length === 0) {
        this.$refs.SnackbarQV.print(
          "orange",
          "Inserire almeno una riga nel DDT.",
          10000
        );
        return;
      }

      if (this.dettaglio.data_documento.includes("/")) {
        let date_time = (this.dettaglio.data_documento =
          this.dettaglio.data_documento.split("/"));
        this.dettaglio.data_documento =
          date_time[2] + "-" + date_time[1] + "-" + date_time[0];
      }

      let documento_tmp = _.cloneDeep(this.dettaglio);

      /* Aggiusto i riferimenti degli allegati
       * delle varie righe di dettaglio. */
      documento_tmp.dettaglio.forEach((d) => {
        if (d.allegati) {
          d.allegati.forEach((a) => {
            a.name = `[DOC${d.id_documento_dettaglio}]` + a.name;
            delete a.file;
          });
        }
      });

      /* Controllo di salvare un numero a 3 cifre decimali
       * sempre in formato stringa per conveniza di BE. */
      documento_tmp.dettaglio.forEach((d) => {
        d.prezzo_totale =
          d.prezzo_totale == null || d.prezzo_totale == ""
            ? (0).toFixed(3)
            : Number(d.prezzo_totale).toFixed(3);
      });

      // Assegno il num_riga
      for (let i = 0; i < documento_tmp.dettaglio.length; i++) {
        documento_tmp.dettaglio[i].num_riga = i + 1;
      }

      /* Recupero gli oggetti di relazione
       * per gli allegati del documento. */
      const allegati_documento_tmp = JSON.parse(
        JSON.stringify(this.allegati_documento)
      );

      /* Ripulisco gli oggetti di relazione degli
       * allegati del documento dai campi inutili. */
      allegati_documento_tmp.forEach((d) => {
        if (d.file) {
          d.name = `[DOC${documento_tmp.id_documento}]` + d.name;
          delete d.file;
        }
      });

      documento_tmp.dettaglio.forEach((d) => {
        if (d.prezzo_totale == "NaN") {
          d.prezzo_totale = 0;
        }
      });

      let richiesta = {
        controller: "Magazzino",
        method: "PUT",
        richiesta: {
          action: "setddtacquisti",
          token: localStorage.user_token,
          id_documento: documento_tmp.id_documento,
          documento: [documento_tmp],
          set_segnalazioni: "true",
          allegati: allegati_documento_tmp,
        },
      };

      this.caricamento = true;

      this.$store
        .dispatch("api", richiesta)
        .then((res) => {
          if (res.status === 200) {
            this.caricamento = false;
            this.setAllegati(res.data);
          } else {
            this.caricamento = false;
            this.$refs.SnackbarQV.print(
              "error",
              "Errore nello scabio di dati col server."
            );
          }
        })
        .catch((err) => {
          this.caricamento = false;
          console.error(err);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, non è stato possibile salvar i dati."
          );
        });
    },
    setAllegati(arg_id_ddt) {
      let count_attachments = 0;

      let form_data = new FormData();
      this.tabella.dati.forEach((d) => {
        if (d.allegati) {
          d.allegati.forEach((a) => {
            count_attachments++;
            form_data.append(a.name, a.file);
          });
        }
      });

      /* Se non ci sono allegati non faccio
       * la chiamata e torno subito indietro. */
      if (count_attachments == 0) {
        this.$refs.SnackbarQV.print("success", "DDT registrato con successo");
        this.new_bolla_dettaglio = arg_id_ddt;
        this.getDocumento();
      } else {
        // Se invece ci sono allegati, li salvo.
        this.caricamento = true;
        new Promise((resolve, reject) => {
          axios
            .post(
              this.$store.state.config.ip + "api/Global/inserisci",
              form_data,
              {
                headers: { Token: localStorage.user_token },
                /*onUploadProgress: (progressEvent) => {
                let progress = Math.round(
                  (progressEvent.loaded / progressEvent.total) * 100
                );
                this.value = progress;
                if (this.value == 100) {
                  this.dialog = true;
                }
              },*/
              }
            )
            .then((result) => {
              this.caricamento = false;
              this.$refs.SnackbarQV.print(
                "success",
                "DDT registrato con successo"
              );
              this.new_bolla_dettaglio = arg_id_ddt;
              this.getDocumento();
              resolve(result);
            })
            .catch((err) => {
              this.caricamento = false;
              this.$refs.SnackbarQV.print(
                "error",
                "Errore di comunicazione col server, non è stato possibile salvar i dati."
              );
              reject(err);
            });
        });
      }
    },
    showDialogAllegatoDocumento() {
      this.dialog_allegato_documento = true;
    },
    showDialogAllegatoRiga(riga) {
      this.dialog_buffer.id_documento_dettaglio = riga.id_documento_dettaglio;
      this.dialog_buffer.allegati = riga.allegati;
      this.dialog_allegato_riga = true;
    },
  },
};
</script>

<style scoped>
.dettaglio_bolla {
  position: relative;
}
.dettaglio_bolla > header {
  border-radius: inherit;
  overflow: hidden;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}
.record_tabella {
  text-align: left;
}
.record_tabella > td {
  text-align: left;
}
.record_tabella[data-deleted] {
  background-color: #ffcccc !important;
}
.record_tabella[data-deleted]:hover {
  background-color: #ffb3b3 !important;
}
</style>